// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:00:29.517Z
// Property: 24Hundred Apartments (ID: 6767906449165580)
// Collections: 24 amenities, 12 floorplans (live), 40 photos, 70 POIs, 3 reviews, 2 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165580",
  "property_external_id": "qm5v2vw",
  "property_zillow_url": "https://www.zillow.com/homedetails/2400-Watermark-Blvd-Oklahoma-City-OK-73134/446957660_zpid/",
  "property_apartments_url": "https://www.apartments.com/24hundred-apartments-oklahoma-city-ok/qm5v2vw/",
  "property_google_business_url": "https://www.google.com/maps/place/24Hundred+Apartments/data=!4m2!3m1!1s0x0:0xb8b4a2fee4c59b11?sa=X&ved=2ahUKEwi4vN_c77ySAxXQEVkFHSKeI_sQ_BJ6BAgREAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "24hundred-apartments",
  "property_name": "24Hundred Apartments",
  "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/24hundred-apartments/",
  "property_domain": null,
  "property_address": "2400 Watermark Blvd",
  "property_full_address": "2400 Watermark Blvd, Oklahoma City, OK, 73134",
  "property_address_1": "2400 Watermark Blvd",
  "property_address_2": null,
  "property_address_city": "Oklahoma City",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73134",
  "property_address_country": "US",
  "property_address_county": "Oklahoma County",
  "property_neighborhood_address": "Northwest Oklahoma City",
  "property_address_latitude": "35.6192",
  "property_address_longitude": "-97.5581",
  "property_email": "24hundred@caseusa.com",
  "property_phone": "(405) 242-1629",
  "property_call_tracking_phone": "866-547-5630",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to 24Hundred Apartments, where modern living meets endless amenities! Choose from spacious one, two, or three-bedroom designs, each featuring high ceilings, stainless appliances, and walk-in closets. Enjoy a resort-style pool, fitness center, and a dog park—all in a gated community close to shops and entertainment. Your new home awaits! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to 24Hundred Apartments, where modern living meets unparalleled convenience in the heart of Oklahoma City! Our community boasts a range of thoughtfully designed floor plans, including one, two, and three-bedroom options, ensuring the perfect fit for your lifestyle. Each apartment features high ceilings, custom cabinetry, and energy-efficient stainless appliances, providing a blend of comfort and style you won't want to miss.\n\nAt 24Hundred, we understand the importance of amenities. That’s why we offer an array of features designed to enhance your living experience. Enjoy our state-of-the-art fitness center, unwind at our resort-style pool with tanning ledges, or gather with friends at our clubhouse or BBQ/picnic area. For pet lovers, our onsite dog park is just the spot for your furry friends to play! With close proximity to shops, entertainment, and parks, your daily adventures are just a stone's throw away.\n\nOur community ensures your peace of mind with 24-hour emergency maintenance and a limited access gated entry. Plus, with flexible payment options and online rental payments, managing your living arrangements has never been easier. Choose from a stunning apartment, contemporary loft, or spacious townhome, each with options for private patios, attached or detached garages, and much more!\n\nExperience refined living at its best—discover your new home at 24Hundred Apartments today. Browse our availability or schedule a personal tour to see firsthand what sets our community apart!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019dbbe7-650c-7454-baf1-5f0c0272012a.webp",
  "property_featured_image_media": {
    "alt_text": "Luxurious swimming pool with lounge chairs and a resort-style cabana area.",
    "public_id": "019dbbe7-650c-7454-baf1-5f0c0272012a",
    "storage_key": "property/6767906449165580/019dbbe7-650c-7454-baf1-5f0c0272012a.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "299",
  "property_year_built": "2022",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.65217391304348",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "225-575",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum of two pets allowed per apartment; no weight limit for cats and dogs.",
  "property_pet_policy_description": "We welcome cats and dogs with no weight limit. Maximum of two pets allowed per apartment. Pet fee: $500 per pet (non‑refundable). Monthly pet rent: $30 per pet. Service animals are not considered pets and are exempt from pet fees and rent.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://24hundredapartmentsokc.securecafe.com/onlineleasing/2400-watermark-blvd-oklahoma-city-ok-73134/floorplans.aspx",
  "property_resident_portal_url": "https://24hundredapartmentsokc.securecafenet.com/residentservices/2400-watermark-blvd-oklahoma-city-ok-73134/userlogin",
  "property_apply_now_url": "https://24hundredapartmentsokc.securecafe.com/onlineleasing/2400-watermark-blvd-oklahoma-city-ok-73134/register",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-7611-7353-944d-f9247ebeb6f8.webp",
  "property_primary_logo_media": {
    "alt_text": "24 Hundred logo",
    "public_id": "019cfb37-7611-7353-944d-f9247ebeb6f8",
    "storage_key": "property/6767906449165580/019cfb37-7611-7353-944d-f9247ebeb6f8.webp",
    "width": 300,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb39-ca93-715b-b96c-df9033643fca.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb39-ca93-715b-b96c-df9033643fca",
    "storage_key": "property/6767906449165580/019cfb39-ca93-715b-b96c-df9033643fca.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb39-f713-7318-a961-46c1987d1fb3.webp",
  "property_mono_white_logo_media": {
    "alt_text": "24 Apartments logo",
    "public_id": "019cfb39-f713-7318-a961-46c1987d1fb3",
    "storage_key": "property/6767906449165580/019cfb39-f713-7318-a961-46c1987d1fb3.webp",
    "width": 300,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb39-feaf-720b-b2ba-f637bbb78f7b.webp",
  "property_mono_black_logo_media": {
    "alt_text": "24 Apartments logo",
    "public_id": "019cfb39-feaf-720b-b2ba-f637bbb78f7b",
    "storage_key": "property/6767906449165580/019cfb39-feaf-720b-b2ba-f637bbb78f7b.webp",
    "width": 300,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#324d58",
  "property_secondary_color": "#a7a8a9",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#ffb548",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "789 - 1246",
  "property_sqft_min": "789",
  "property_sqft_max": "1246",
  "property_price_range": "1189 - 1699",
  "property_price_min": "1189",
  "property_price_max": "1699",
  "property_available_units": 15,
  "property_facebook_url": "https://www.facebook.com/24HundredApts/",
  "property_instagram_url": "https://www.instagram.com/24hundredapts/?hl=en",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJV_LVlhh1zUUREZvF5P6itLg",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/24hundred-apartments-oklahoma-city",
  "property_tiktok_url": "https://www.tiktok.com/@24hundredapts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to 24Hundred Apartments",
  "property_home_romance_title": "Embrace a New Beginning in Your Dream Apartment Home",
  "property_home_amenities_blurb": "Welcome to 24Hundred Apartments in Oklahoma City, where modern living meets comfort. Choose from thoughtfully designed one, two, or three-bedroom layouts, complete with high ceilings, custom cabinetry, and stylish finishes. Enjoy resort-style amenities like a sparkling pool, fitness center, and an on-site dog park, all within a vibrant community.",
  "property_home_floorplans_blurb": "Welcome to 24Hundred Apartments in the heart of Oklahoma City, where modern living meets style. Choose from our thoughtfully designed one, two, and three-bedroom floor plans that cater to your unique lifestyle. Browse our available apartment homes today and discover the perfect space to call your own!",
  "property_home_gallery_blurb": "At 24Hundred Apartments in Oklahoma City, your ideal lifestyle awaits! Choose from a variety of one, two, and three-bedroom floor plans featuring luxurious amenities like a resort-style pool, fitness center, and a dog park. Picture yourself unwinding on your private balcony or in our stylish clubhouse today!",
  "property_home_neighborhood_blurb": "Welcome to 24Hundred Apartments in vibrant Oklahoma City, where spacious one, two, and three-bedroom floor plans await you. Nestled near attractions like the University of Central Oklahoma and the engaging Blue Zoo, you'll enjoy a lifestyle enriched by parks, museums, and fitness options. Uncover your new home today!",
  "property_home_reviews_blurb": "Welcome to 24Hundred Apartments, where serenity meets style in Oklahoma City. Our residents rave about the “beautiful, glamorous” apartments and the “well-maintained” amenities, highlighting the friendly, responsive team that feels like family. Experience a peaceful retreat just minutes from all the city has to offer!",
  "property_neighborhood_blurb": "At 24Hundred Apartments in Oklahoma City, vibrant living meets convenience. Nestled near the University of Central Oklahoma, Clark Crew BBQ, and stunning parks like Martin Park Nature Center, our community harmonizes modern comfort with local charm. Dive into the rich experiences surrounding you—there’s something for everyone!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Experience the vibrant lifestyle at 24Hundred Apartments in Oklahoma City, where beautifully designed one, two, and three-bedroom homes await. Enjoy resort-style amenities like our sparkling pool, modern fitness center, and cozy clubhouse. Embrace convenience with online payments and onsite management, all within a gated community tailored for your comfort.",
  "property_applynow_blurb": "Find your oasis at 24Hundred Apartments in Oklahoma City! Choose from inviting one, two, or three-bedroom layouts adorned with high ceilings, custom cabinetry, and private balconies. Enjoy resort-style amenities like a sparkling pool, fitness center, and an onsite dog park. Embrace comfort and convenience—lease your new home online today!",
  "property_contactus_blurb": "At 24Hundred Apartments in vibrant Oklahoma City, our thoughtfully designed one, two, and three-bedroom floor plans offer the perfect blend of comfort and style. Whether you desire open layouts or cozy retreats, we have the ideal space for you. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At 24Hundred Apartments in Oklahoma City, we offer a variety of thoughtfully designed floor plans, from cozy one-bedroom retreats to spacious three-bedroom homes. Have questions about our vibrant community? Our FAQs page is brimming with insights to help you choose your perfect living space.",
  "property_floorplans_blurb": "At 24Hundred Apartments in vibrant Oklahoma City, your ideal home awaits. Choose from thoughtfully designed one, two, and three-bedroom floor plans that blend style and comfort. Each space is crafted for modern living, ensuring you'll feel right at home. Browse our available apartment homes and uncover your perfect fit today!",
  "property_gallery_blurb": "Imagine life at 24Hundred Apartments in Oklahoma City, where stylish one, two, and three-bedroom layouts meet upscale amenities. From the resort-style pool and dog park to the inviting clubhouse and fitness center, every detail invites relaxation and connection. Picture yourself living here and enjoying the vibrant community and luxurious comfort!",
  "property_interactivemap_blurb": "Welcome to 24Hundred Apartments in vibrant Oklahoma City, where comfort meets convenience. Choose from our selection of one, two, or three-bedroom layouts, complete with high ceilings and private balconies. Unwind by the resort-style pool or socialize in the clubhouse. Utilize our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At 24Hundred Apartments in vibrant Oklahoma City, we embrace your furry companions with open arms! Bring along your cats and dogs—two per apartment—while enjoying spacious living and a pet-friendly community. With no weight restrictions, let your pets revel in their new home, unburdened by breed limitations!",
  "property_referafriend_blurb": "At 24Hundred Apartments in vibrant Oklahoma City, we offer spacious one, two, and three-bedroom floor plans designed for your comfort. Invite your friends to experience our welcoming community. After all, great friends make great neighbors—refer a friend today and enjoy the perks of living together in style!",
  "property_residentaccess_blurb": "At 24Hundred Apartments in Oklahoma City, you’ll find thoughtfully designed one, two, and three-bedroom floor plans that cater to your lifestyle. Elevate your living experience by accessing our resident portal—manage rent, maintenance requests, and more—effortlessly enhancing your comfort at home. Sign in today for seamless living!",
  "property_reviews_blurb": "At 24Hundred Apartments in Oklahoma City, residents rave about the peaceful environment and exceptional service. “The team has always been accommodating, kind, and responsive,” ensures a worry-free home experience. With top-notch amenities and lush landscapes, it’s easy to see why this community feels like a beautiful retreat. ",
  "property_created_at": "1753982375837",
  "property_scheduletour_blurb": "At 24Hundred Apartments in the heart of Oklahoma City, vibrant living awaits in our thoughtfully designed one, two, and three-bedroom floor plans. Embrace a lifestyle tailored to you and connect with our residents to hear firsthand about their experiences. Schedule a tour today and visualize your new home!",
  "property_thankyou_blurb": "Thank you for reaching out to 24Hundred Apartments in vibrant Oklahoma City! With a range of thoughtfully designed floor plans—one, two, and three bedrooms—we're here to help you find your perfect home. Keep an eye on your inbox; our dedicated team will be in touch soon!",
  "property_virtualtours_blurb": "Immerse yourself in the stylish living spaces of 24Hundred Apartments in Oklahoma City. With thoughtfully designed one, two, and three-bedroom floor plans, there's a perfect fit for everyone. Experience our vibrant community and beautiful interiors—take a virtual tour today and envision your new home!",
  "property_copyright": "2025 All Rights Reserved. 24Hundred Apartments",
  "property_seo_title_home": "24Hundred Apartments |  Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_home": "Find your oasis at 24Hundred Apartments! Choose from stylish one to three-bedroom homes with stunning amenities and a prime location in Oklahoma City.",
  "property_seo_title_floorplans": "Floor Plans | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at 24Hundred Apartments in OKC! Choose from stylish one, two, or three-bedroom floor plans tailored for your lifestyle. Browse today!",
  "property_seo_title_amenities": "Amenities | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury at 24Hundred Apartments in OKC! Enjoy a pool, fitness center, gourmet kitchens, and pet-friendly spaces. Elevate your lifestyle!",
  "property_seo_title_gallery": "Gallery | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_gallery": "Experience modern living at 24Hundred Apartments in OKC! From spacious floor plans to resort-style amenities, imagine your perfect home today!",
  "property_seo_title_virtualtours": "Virtual Tours | 24Hundred Apartments Apartments",
  "property_seo_description_virtualtours": "Discover 24Hundred Apartments in Oklahoma City! Explore spacious one to three-bedroom homes with a virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | 24Hundred Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your oasis at 24Hundred Apartments in OKC! Explore our map for spacious homes, stunning amenities, and vibrant community living!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood around 24Hundred Apartments in Oklahoma City, featuring local favorites and hotspots that make it feel like home!",
  "property_seo_title_contact": "Contact Us | 24Hundred Apartments",
  "property_seo_description_contact": "Connect with 24Hundred Apartments in OKC! Whether you need a one, two, or three-bedroom plan, our leasing team is here to assist. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_faqs": "Find answers to your queries at 24Hundred Apartments in Oklahoma City! Enjoy modern amenities, spacious layouts, and a vibrant community. Check our FAQs now!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_reviews": "Experience modern living at 24Hundred Apartments in OKC! From stunning floor plans to amazing amenities, see why our residents love calling us home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_applynow": "Live at 24Hundred Apartments in OKC! Choose from stylish 1-3 bedroom homes with resort-style amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | 24Hundred Apartments",
  "property_seo_description_residentaccess": "Login to your 24Hundred Apartments resident portal! Manage rent, request maintenance, and enjoy easy access to your home essentials in Oklahoma City.",
  "property_seo_title_referafriend": "Refer A Friend | 24Hundred Apartments",
  "property_seo_description_referafriend": "Refer a friend to 24Hundred Apartments in Oklahoma City and foster a vibrant community. Great friends make great neighbors—join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | 24Hundred Apartments",
  "property_seo_description_scheduletour": "Experience modern living at 24Hundred Apartments in OKC! Join us for a tour and see firsthand why our vibrant community feels like home. Schedule yours today!",
  "property_seo_title_privacy": "Privacy Policy | 24Hundred Apartments",
  "property_seo_description_privacy": "At 24Hundred Apartments, your privacy is a priority. Discover how we secure your information and living environment. View our policy now!",
  "property_seo_title_accessibility": "Website Accessibility | 24Hundred Apartments",
  "property_seo_description_accessibility": "At 24Hundred Apartments in OKC, we champion accessibility for all. Join us in fostering a community where everyone feels at home!",
  "property_seo_title_sitemap": "Sitemap | 24Hundred Apartments",
  "property_seo_description_sitemap": "Uncover the layout of 24Hundred Apartments in Oklahoma City. Navigate our sitemap for a glimpse into your future home, amenities, and community details today!",
  "property_seo_title_thankyou": "Thank You | 24Hundred Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out! Get ready to experience modern living at 24Hundred Apartments in Oklahoma City. Your journey to comfort starts here!",
  "property_seo_title_pets": "Pet Policy | Apartments in Oklahoma City, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787864341012",
  "amenities": [
    {
      "id": "ec_017c20b68accc29f84311702",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127396135",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bdb3c69f2c02dd03cdf174e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127396137",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a0537b17e36839cd4f70f68f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127396138",
      "title": "Onsite Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6a5d387b94171a2fd9ae51b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127396139",
      "title": "Close to Parks",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_18b306708dd34bd3761fe67c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127396140",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_103a4abec8006e104525d7f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127396141",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_723e3f9c5f74c72edfb773ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127396142",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dff680d08c03da8e499ee878",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127396143",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e83fd9ad7b5dd5ee28e7d06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127396144",
      "title": "Pool Area Cabana",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a2e980181a714a13ce904a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127396145",
      "title": "Resort Style Pool w/ Tanning Ledges",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7731175f0af1fa882be8b6a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127396147",
      "title": "Limited Access Gated Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cb9a4662c2db2e65b5b31e99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127396148",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_01f601b9fb7d7d857a4563c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127397645",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8f98b76aaf6b1f3ddd5e0beb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127397646",
      "title": "Choice of Townhome, Loft, or Apartment",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_805bead8da792e4a7041b269",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127397647",
      "title": "Custom Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f106d4e7b20facd3609efdf7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127397648",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a58ca03e53d2f4dadbb687ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127397650",
      "title": "Attached* or Detached Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a4ad681fec6aa5cf6da727fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127397651",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e966b5e17d60741545fbde55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127397652",
      "title": "Central Heat & Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7653cc70860952bc85acfada",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127397653",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d99022df1a4dbcbcad200af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127397654",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fabae223c067e523181750a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127397655",
      "title": "LED Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a22ce87c731d21f80768c339",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127397656",
      "title": "Private Patio or Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f0ff1cb6174afa905d52db9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "yardi",
      "external_id": "127397657",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_f8507fa4-93b6-4304-9066-a3bcc10f75dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-6a42-76a8-916f-5bf11eec2dfd.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019db713-6a42-76a8-916f-5bf11eec2dfd",
        "storage_key": "property/6767906449165580/019db713-6a42-76a8-916f-5bf11eec2dfd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this stylish kitchen, featuring dark wood cabinetry, sleek stainless steel appliances, and elegant marble countertops. Perfect for whipping up your favorite meals.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c0d87ee-1132-41ad-96bf-e589f46aa98d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-63b7-72e1-9ba1-7608b32dff77.webp",
      "image_media": {
        "alt_text": "A stylish bedroom with a king-sized bed, modern decor, and a ceiling fan.",
        "public_id": "019db713-63b7-72e1-9ba1-7608b32dff77",
        "storage_key": "property/6767906449165580/019db713-63b7-72e1-9ba1-7608b32dff77.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a plush king-sized bed, contemporary wall art, and a ceiling fan for ultimate relaxation.",
      "link": "",
      "alt_text": "A stylish bedroom with a king-sized bed, modern decor, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_306fe221-01aa-4644-adcd-a1e2368b53db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-6253-7515-a938-4b5dd162b177.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with marble countertop, dual sinks, and ample storage. Includes decorative items and a large mirror.",
        "public_id": "019db713-6253-7515-a938-4b5dd162b177",
        "storage_key": "property/6767906449165580/019db713-6253-7515-a938-4b5dd162b177.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience the elegance of this beautifully appointed bathroom, featuring a sleek vanity with a marble countertop, modern fixtures, and generous storage space. Perfect for your daily routine.",
      "link": "",
      "alt_text": "Modern bathroom vanity with marble countertop, dual sinks, and ample storage. Includes decorative items and a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_55572e39-3da7-4753-9593-007e19ee558f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-52af-71c9-b1c2-473289cc53a9.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with stainless steel appliances, white cabinets, and a marble countertop.",
        "public_id": "019db713-52af-71c9-b1c2-473289cc53a9",
        "storage_key": "property/6767906449165580/019db713-52af-71c9-b1c2-473289cc53a9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover this stunning apartment kitchen, featuring sleek stainless steel appliances, ample white cabinetry, and elegant marble countertops. Perfect for culinary enthusiasts.",
      "link": "",
      "alt_text": "Modern apartment kitchen with stainless steel appliances, white cabinets, and a marble countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_53aa0415-ca23-4cf8-9dc4-913070e79c75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-5a7a-706c-a6e1-d07a2822bb7c.webp",
      "image_media": {
        "alt_text": "Modern living room with a green sectional sofa, patterned accent chairs, a glass coffee table, and a TV.",
        "public_id": "019db713-5a7a-706c-a6e1-d07a2822bb7c",
        "storage_key": "property/6767906449165580/019db713-5a7a-706c-a6e1-d07a2822bb7c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this stylish living room featuring a plush green sectional, comfortable accent chairs, and a modern entertainment center.",
      "link": "",
      "alt_text": "Modern living room with a green sectional sofa, patterned accent chairs, a glass coffee table, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_abc51b32-8e9a-499e-a538-f841ceab5183",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-45d5-70e2-a888-0c85fb83d25a.webp",
      "image_media": {
        "alt_text": "Spacious living room with a white sofa, coffee table, desk, and large windows.",
        "public_id": "019db713-45d5-70e2-a888-0c85fb83d25a",
        "storage_key": "property/6767906449165580/019db713-45d5-70e2-a888-0c85fb83d25a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and airy living space featuring a comfortable sofa, stylish coffee table, and a dedicated workspace, perfect for relaxation and productivity.",
      "link": "",
      "alt_text": "Spacious living room with a white sofa, coffee table, desk, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d01f80f8-6586-4e3d-bc46-0c4436437306",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-512d-76b8-9e30-48ee01534268.webp",
      "image_media": {
        "alt_text": "Modern gray kitchen with white subway tile backsplash and stainless steel appliances.",
        "public_id": "019db713-512d-76b8-9e30-48ee01534268",
        "storage_key": "property/6767906449165580/019db713-512d-76b8-9e30-48ee01534268.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring sleek gray cabinetry, quartz countertops, and stainless steel appliances, perfect for preparing meals.",
      "link": "",
      "alt_text": "Modern gray kitchen with white subway tile backsplash and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_927b2612-14fd-4bee-98ce-e604ebc2f463",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-3fef-718d-8158-7b02371903af.webp",
      "image_media": {
        "alt_text": "Queen-size bed with white bedding and a burnt orange throw blanket, nightstand, dresser with mirror, and ceiling fan.",
        "public_id": "019db713-3fef-718d-8158-7b02371903af",
        "storage_key": "property/6767906449165580/019db713-3fef-718d-8158-7b02371903af.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable queen-size bed with stylish bedding, a spacious dresser, and a ceiling fan for comfort.",
      "link": "",
      "alt_text": "Queen-size bed with white bedding and a burnt orange throw blanket, nightstand, dresser with mirror, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5443bbff-3b11-48f3-bc03-13313b2e6575",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-3a2d-744e-8c98-7aa03b905650.webp",
      "image_media": {
        "alt_text": "Bathroom with marble countertop, dark wood vanity, and decorative accents.",
        "public_id": "019db713-3a2d-744e-8c98-7aa03b905650",
        "storage_key": "property/6767906449165580/019db713-3a2d-744e-8c98-7aa03b905650.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A stylish bathroom featuring a marble vanity, dark wood cabinets, and modern decor, creating a spa-like atmosphere.",
      "link": "",
      "alt_text": "Bathroom with marble countertop, dark wood vanity, and decorative accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_73ba1ad7-a5d4-4d89-8522-2bee3f6df3a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-3db6-754c-b5e3-26c8c7596d53.webp",
      "image_media": {
        "alt_text": "Bathroom with a shower/tub combo, vanity, and toilet.",
        "public_id": "019db713-3db6-754c-b5e3-26c8c7596d53",
        "storage_key": "property/6767906449165580/019db713-3db6-754c-b5e3-26c8c7596d53.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a white tiled shower/tub combo, a marble vanity with a sink, and a toilet.",
      "link": "",
      "alt_text": "Bathroom with a shower/tub combo, vanity, and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e6e106ec-e1b8-4942-bddf-6f2c907bb393",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-4055-7381-853c-3f42e6e6e86a.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and decorative wall art.",
        "public_id": "019db713-4055-7381-853c-3f42e6e6e86a",
        "storage_key": "property/6767906449165580/019db713-4055-7381-853c-3f42e6e6e86a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable queen-size bed, a stylish nightstand with a lamp and decorative items, and an elegant mirrored wall art above the headboard.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e4f5c111-55f9-41ad-90bc-cd2f456d7a15",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-4598-71de-b033-fed6670a8894.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with a large mirror, modern sink, and decorative art.",
        "public_id": "019db713-4598-71de-b033-fed6670a8894",
        "storage_key": "property/6767906449165580/019db713-4598-71de-b033-fed6670a8894.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and airy bathroom featuring a spacious vanity with a marble countertop, contemporary sink, and stylish decor. Ample storage and elegant finishes complete this inviting space.",
      "link": "",
      "alt_text": "Bathroom vanity with a large mirror, modern sink, and decorative art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_29dac716-cfea-4cf2-8460-5e7dc671c0b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-45c0-718a-ac8a-b12d1d11d6b5.webp",
      "image_media": {
        "alt_text": "A beautifully decorated bedroom with a queen-size bed, dresser, and decorative wall art.",
        "public_id": "019db713-45c0-718a-ac8a-b12d1d11d6b5",
        "storage_key": "property/6767906449165580/019db713-45c0-718a-ac8a-b12d1d11d6b5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover comfort and style in this inviting bedroom, featuring a plush queen-size bed, elegant dresser, and charming decorative accents. Perfect for relaxation.",
      "link": "",
      "alt_text": "A beautifully decorated bedroom with a queen-size bed, dresser, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_880773ac-83a9-4168-8b7f-99c5d9049af4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-429a-7798-b6e8-a599e4ef691b.webp",
      "image_media": {
        "alt_text": "Modern bathroom with gray vanity, marble countertop, and decorative artwork.",
        "public_id": "019db713-429a-7798-b6e8-a599e4ef691b",
        "storage_key": "property/6767906449165580/019db713-429a-7798-b6e8-a599e4ef691b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and elegantly designed bathroom featuring a gray vanity with a marble countertop, ample storage, and tasteful decorative accents.",
      "link": "",
      "alt_text": "Modern bathroom with gray vanity, marble countertop, and decorative artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_784d8aff-368c-4c34-8c45-f3823657dd5f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-2e07-7799-b022-b7c04c4c80ef.webp",
      "image_media": {
        "alt_text": "Primary bedroom with queen-size bed, bedside tables, dresser, and wall decor.",
        "public_id": "019db713-2e07-7799-b022-b7c04c4c80ef",
        "storage_key": "property/6767906449165580/019db713-2e07-7799-b022-b7c04c4c80ef.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious primary bedroom featuring a queen-size bed with a mustard-yellow comforter, elegant bedside tables, a dresser, and unique woven wall art.",
      "link": "",
      "alt_text": "Primary bedroom with queen-size bed, bedside tables, dresser, and wall decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b8d0c486-de6f-4913-b63f-6c832dfaf51f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-1325-738b-a5ec-a380939daf6f.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas. Buildings and clubhouse in background.",
        "public_id": "019db713-1325-738b-a5ec-a380939daf6f",
        "storage_key": "property/6767906449165580/019db713-1325-738b-a5ec-a380939daf6f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Dive into relaxation at our sparkling swimming pool, surrounded by comfortable lounge chairs and shaded umbrellas. Perfect for a refreshing escape on a sunny day.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas. Buildings and clubhouse in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_db8c4872-4339-4a3e-9c05-a3c1c3988688",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-162d-7093-9142-dfdb98a09990.webp",
      "image_media": {
        "alt_text": "Welcome to 24 Unleashed pet friendly park sign with apartment buildings in the background.",
        "public_id": "019db713-162d-7093-9142-dfdb98a09990",
        "storage_key": "property/6767906449165580/019db713-162d-7093-9142-dfdb98a09990.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our dedicated pet-friendly park, perfect for your furry companions to play and explore, with comfortable seating for residents.",
      "link": "",
      "alt_text": "Welcome to 24 Unleashed pet friendly park sign with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_001c0547-87f3-4a33-b7a5-9e9e922554e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db712-fed4-73ac-bc8b-667caa2a0d34.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, free weights, and cardio equipment.",
        "public_id": "019db712-fed4-73ac-bc8b-667caa2a0d34",
        "storage_key": "property/6767906449165580/019db712-fed4-73ac-bc8b-667caa2a0d34.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide range of weight machines, free weights, and cardio equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with weight machines, free weights, and cardio equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_92aae601-2586-44c3-83ad-353a83233b91",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-236d-74d8-88da-bf84ef5d78a4.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and view of bedroom.",
        "public_id": "019db713-236d-74d8-88da-bf84ef5d78a4",
        "storage_key": "property/6767906449165580/019db713-236d-74d8-88da-bf84ef5d78a4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a modern fireplace, comfortable seating, and a glimpse into the private bedroom. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with fireplace and view of bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b7cc1221-2fb2-43d2-86c6-1c29a04d2242",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-2095-705e-80e9-f3d6fdb27349.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and a marble island.",
        "public_id": "019db713-2095-705e-80e9-f3d6fdb27349",
        "storage_key": "property/6767906449165580/019db713-2095-705e-80e9-f3d6fdb27349.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Showcasing a stylish kitchen featuring stainless steel appliances, ample cabinet space, and a beautiful marble-topped island, perfect for meal preparation and casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and a marble island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_24b525bc-36ee-42ab-8186-f1fee9cc882a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db712-fc5b-76b1-bfe5-b375ad4ee20a.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, weight racks, and a bench.",
        "public_id": "019db712-fc5b-76b1-bfe5-b375ad4ee20a",
        "storage_key": "property/6767906449165580/019db712-fc5b-76b1-bfe5-b375ad4ee20a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio machines, free weights, and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, weight racks, and a bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c60cfa79-5592-48b5-9472-87762bfeba17",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db712-fe6c-772f-9542-3eb516fac728.webp",
      "image_media": {
        "alt_text": "Exterior of the apartment building's main entrance with stone pillars and modern siding.",
        "public_id": "019db712-fe6c-772f-9542-3eb516fac728",
        "storage_key": "property/6767906449165580/019db712-fe6c-772f-9542-3eb516fac728.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Welcome to the community clubhouse, featuring a modern design with stone accents and ample natural light, providing a perfect gathering space.",
      "link": "",
      "alt_text": "Exterior of the apartment building's main entrance with stone pillars and modern siding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0aa90e8f-69e2-4e0e-acbe-8165709b36e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db712-fc59-75de-bf70-fb69e75c8a89.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and brick accents.",
        "public_id": "019db712-fc59-75de-bf70-fb69e75c8a89",
        "storage_key": "property/6767906449165580/019db712-fc59-75de-bf70-fb69e75c8a89.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Attractive exterior of the apartment building showcasing its multiple levels, balconies, and well-maintained landscaping.",
      "link": "",
      "alt_text": "Exterior view of a multi-story apartment building with balconies and brick accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_723c8a48-be1e-4379-921d-3b2d321515fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db712-fcd7-71ff-9798-281b2c1850c1.webp",
      "image_media": {
        "alt_text": "Resort-style pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "019db712-fcd7-71ff-9798-281b2c1850c1",
        "storage_key": "property/6767906449165580/019db712-fcd7-71ff-9798-281b2c1850c1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our stunning resort-style pool, complete with comfortable lounge chairs and cabanas. Perfectly situated amidst beautiful apartment buildings and lush landscaping.",
      "link": "",
      "alt_text": "Resort-style pool with lounge chairs and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_35b7a31b-826c-4bfd-95f6-bddf15498aca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-0f16-734d-8d35-edd064ae79c8.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex buildings surrounding a pond and pool.",
        "public_id": "019db713-0f16-734d-8d35-edd064ae79c8",
        "storage_key": "property/6767906449165580/019db713-0f16-734d-8d35-edd064ae79c8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover luxury living with our spacious apartments, resort-style pool, and serene pond. Experience comfort and convenience in our vibrant community.",
      "link": "",
      "alt_text": "Aerial view of apartment complex buildings surrounding a pond and pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_224f55b5-bf90-4719-922a-f64616ba6118",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-0612-734a-8d53-a69a695ab2f0.webp",
      "image_media": {
        "alt_text": "Outdoor fire pit with lounge chairs in front of a building with stone accents and large windows.",
        "public_id": "019db713-0612-734a-8d53-a69a695ab2f0",
        "storage_key": "property/6767906449165580/019db713-0612-734a-8d53-a69a695ab2f0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the fire pit and enjoy the outdoors with comfortable lounge seating. A perfect spot for gatherings and unwinding.",
      "link": "",
      "alt_text": "Outdoor fire pit with lounge chairs in front of a building with stone accents and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_69f9c8ee-b08d-4538-b88a-3ee8886cb1e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db712-eb48-7482-82c2-5740f853ac1e.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with a parking lot and landscaping.",
        "public_id": "019db712-eb48-7482-82c2-5740f853ac1e",
        "storage_key": "property/6767906449165580/019db712-eb48-7482-82c2-5740f853ac1e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "A modern apartment building exterior with stone and siding accents, featuring a parking lot, manicured lawns, and a glimpse of a pond in the background.",
      "link": "",
      "alt_text": "Exterior of apartment building with a parking lot and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b33e0907-b467-4ac2-bfeb-b94bde9a99c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db710-e370-72c4-b244-9973ebc9a65e.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
        "public_id": "019db710-e370-72c4-b244-9973ebc9a65e",
        "storage_key": "property/6767906449165580/019db710-e370-72c4-b244-9973ebc9a65e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stunning exterior view of apartment buildings featuring private balconies and beautifully maintained grounds, offering a picturesque living environment.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ef02074c-8691-4728-814d-c3ae5981aae6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db710-c272-7728-9955-24db228de5fc.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with garages and balconies.",
        "public_id": "019db710-c272-7728-9955-24db228de5fc",
        "storage_key": "property/6767906449165580/019db710-c272-7728-9955-24db228de5fc.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of an apartment building featuring multiple garages and balconies, set against a clear blue sky.",
      "link": "",
      "alt_text": "Apartment building exterior with garages and balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d19e7420-125c-4897-93d5-2de36c2847fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db710-be9c-713d-bd8c-cadd750c4677.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and walkways.",
        "public_id": "019db710-be9c-713d-bd8c-cadd750c4677",
        "storage_key": "property/6767906449165580/019db710-be9c-713d-bd8c-cadd750c4677.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Beautifully maintained community grounds featuring apartment buildings with balconies, picnic areas, and green spaces.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with manicured lawns and walkways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_94d2a83e-ab2d-4a2e-bda4-9e28c6c48df7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db710-b9a3-725f-802c-69c3f0aa7bff.webp",
      "image_media": {
        "alt_text": "Apartment complex with a pond and fountain, surrounded by manicured lawns and trees.",
        "public_id": "019db710-b9a3-725f-802c-69c3f0aa7bff",
        "storage_key": "property/6767906449165580/019db710-b9a3-725f-802c-69c3f0aa7bff.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy the serene ambiance of our community, featuring a beautiful pond with a fountain, lush green spaces, and comfortable seating areas for relaxation.",
      "link": "",
      "alt_text": "Apartment complex with a pond and fountain, surrounded by manicured lawns and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c6e3ce7d-a9b0-47f9-aaf8-1e4717b9ce97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db710-a85b-766a-a44c-ece0b19a26d5.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with in-water loungers and lounge chairs, surrounded by apartment buildings.",
        "public_id": "019db710-a85b-766a-a44c-ece0b19a26d5",
        "storage_key": "property/6767906449165580/019db710-a85b-766a-a44c-ece0b19a26d5.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with in-water loungers and plenty of space to relax. The perfect amenity for soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with in-water loungers and lounge chairs, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6f712591-287f-462c-98ff-f0a8970544cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db710-ac98-7384-b558-dc934250c3a9.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with green lawn and blue sky.",
        "public_id": "019db710-ac98-7384-b558-dc934250c3a9",
        "storage_key": "property/6767906449165580/019db710-ac98-7384-b558-dc934250c3a9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Modern apartment buildings with balconies, surrounded by a well-maintained lawn and clear blue sky.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with green lawn and blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bd58bb6a-ece6-45bd-a210-b80fcdd04174",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db710-a20d-7463-8882-09d462990fb1.webp",
      "image_media": {
        "alt_text": "Luxury apartment complex swimming pool with lounge chairs and cabanas.",
        "public_id": "019db710-a20d-7463-8882-09d462990fb1",
        "storage_key": "property/6767906449165580/019db710-a20d-7463-8882-09d462990fb1.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip or relax by the sparkling pool at our luxury apartment community. Featuring comfortable lounge chairs and shaded cabanas for ultimate relaxation.",
      "link": "",
      "alt_text": "Luxury apartment complex swimming pool with lounge chairs and cabanas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8f63af20-7161-4063-ace8-4dc7b1717a97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db710-9ea3-745f-a771-8b27ce3d2ade.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with two stainless steel grills, picnic table, and apartment buildings in the background.",
        "public_id": "019db710-9ea3-745f-a771-8b27ce3d2ade",
        "storage_key": "property/6767906449165580/019db710-9ea3-745f-a771-8b27ce3d2ade.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking with our built-in grills and comfortable picnic area. Perfect for gathering with friends and family.",
      "link": "",
      "alt_text": "Outdoor grilling station with two stainless steel grills, picnic table, and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5c40b948-19fc-4a3c-aa84-b4e582742685",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db710-8104-71aa-83e9-9d54f7257493.webp",
      "image_media": {
        "alt_text": "Apartment complex with a fenced-in dog park featuring agility equipment and benches.",
        "public_id": "019db710-8104-71aa-83e9-9d54f7257493",
        "storage_key": "property/6767906449165580/019db710-8104-71aa-83e9-9d54f7257493.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy our spacious, fenced-in dog park, complete with agility equipment and comfortable seating for you and your furry friends.",
      "link": "",
      "alt_text": "Apartment complex with a fenced-in dog park featuring agility equipment and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c81caba1-6a5c-4075-acab-617f7ec163a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db710-9c16-71d9-8296-e3a578042410.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with chairs and a TV, adjacent to grilling stations.",
        "public_id": "019db710-9c16-71d9-8296-e3a578042410",
        "storage_key": "property/6767906449165580/019db710-9c16-71d9-8296-e3a578042410.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor living with comfortable seating and convenient grilling stations for entertaining guests.",
      "link": "",
      "alt_text": "Outdoor seating area with chairs and a TV, adjacent to grilling stations.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fbd2c702-f87e-4bef-8f6e-3a5230c73d97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db710-8de2-76cc-9b12-b9a0c77bb8ff.webp",
      "image_media": {
        "alt_text": "Monument sign for 100 24 Apartments with leasing flags",
        "public_id": "019db710-8de2-76cc-9b12-b9a0c77bb8ff",
        "storage_key": "property/6767906449165580/019db710-8de2-76cc-9b12-b9a0c77bb8ff.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "The monument sign for 100 24 Apartments welcomes visitors with prominent branding and open leasing flags.",
      "link": "",
      "alt_text": "Monument sign for 100 24 Apartments with leasing flags",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2667b5ef-0cc8-40d0-aaa9-88f384f8b28e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db710-682c-754c-9f57-12504fbe8748.webp",
      "image_media": {
        "alt_text": "Pet park with agility equipment at a multifamily property.",
        "public_id": "019db710-682c-754c-9f57-12504fbe8748",
        "storage_key": "property/6767906449165580/019db710-682c-754c-9f57-12504fbe8748.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy our dedicated pet park, complete with agility obstacles for your furry friends. A great space for pets to play and socialize within the community.",
      "link": "",
      "alt_text": "Pet park with agility equipment at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f6e9a057-42aa-483c-afe0-8afed6c8e74c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db710-7027-7333-83cd-c9ee6ff2b9cf.webp",
      "image_media": {
        "alt_text": "Dog park with red agility tunnel and green grass outside apartment buildings.",
        "public_id": "019db710-7027-7333-83cd-c9ee6ff2b9cf",
        "storage_key": "property/6767906449165580/019db710-7027-7333-83cd-c9ee6ff2b9cf.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, perfect for your furry friends to play and socialize in a safe, fenced-in area. Features an agility tunnel and plenty of green space.",
      "link": "",
      "alt_text": "Dog park with red agility tunnel and green grass outside apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_e4628024-a7a5-40ab-b3b8-547f39774d02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Topgolf Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "13313 Pawnee Dr, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Entertainment venue blending technology, dining, and golf with a sports bar, and rooftop seating.",
      "poi_long_description": "People say this restaurant offers a fun atmosphere with games, kid clubs, and toddler clubs. They also highlight the affordable pricing, especially for groups, and the friendly and helpful staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-f28f-70bb-991e-ae1775f51bca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-f28f-70bb-991e-ae1775f51bca",
        "storage_key": "property/6767906449165580/019cfb37-f28f-70bb-991e-ae1775f51bca.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://topgolf.com/us/oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17880991546737991946&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-oklahoma-city",
      "poi_latitude": "35.6027127",
      "poi_longitude": "-97.5351879",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-607-7154",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-c88682c2107b",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc0r8qRocsocRCqEU_xILJvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_34f82fd3-a30d-49ad-93e5-88907ecb4910",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "8400 N Oklahoma Ave, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Bar with games such as pickleball and bocce and an on-site restaurant menu that encompasses wings to chicken sandwiches.",
      "poi_long_description": "People say this restaurant offers a fun day of pickleball, cornhole, drinks, and snacks. They also highlight the friendly staff, the perfect atmosphere for all ages, and the great experience for families and friends.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-f28f-70bb-991e-b32cf28e2c1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-f28f-70bb-991e-b32cf28e2c1e",
        "storage_key": "property/6767906449165580/019cfb37-f28f-70bb-991e-b32cf28e2c1e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://chickennpickle.com/location/oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4621211403201137082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chicken-n-pickle---oklahoma-city",
      "poi_latitude": "35.5570464",
      "poi_longitude": "-97.5088888",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-839-7011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-c88682c2107b",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDbbROHYZsocRusnJd0nXIUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_4f05b6dc-4f67-4e6b-837e-dca45c2cbfd6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Main Event Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "1441 W Memorial Rd, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Family-friendly venue offering bowling, laser tag and arcade games, along with pizza and burgers, plus a ropes course.",
      "poi_long_description": "People say this restaurant offers a variety of fun games, including bowling, laser tag, and arcade games, and the pizza is great. They also highlight the friendly staff, the fun atmosphere, and the good drinks.\n\nOther reviews mention some games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-f28a-713d-9a59-490e3b8b4c21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-f28a-713d-9a59-490e3b8b4c21",
        "storage_key": "property/6767906449165580/019cfb37-f28a-713d-9a59-490e3b8b4c21.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mainevent.com/locations/oklahoma/oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=10621058190493493742&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "main-event-oklahoma-city",
      "poi_latitude": "35.6102071",
      "poi_longitude": "-97.5381584",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-751-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-c88682c2107b",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8bkHxccsocR7ikexyaUZZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_55655e08-20bd-422d-bacb-546f45164f37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2100 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Chain serving steaks and ribs in a casual setting featuring a jukebox and line dancers.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, chicken fried steak, and ribs, and the rolls with cinnamon butter are a highlight. They also highlight the friendly and accommodating staff, and the family-friendly atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-f29c-72eb-b634-33e1791cfe40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-f29c-72eb-b634-33e1791cfe40",
        "storage_key": "property/6767906449165580/019cfb37-f29c-72eb-b634-33e1791cfe40.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/oklahoma-city-north-memorial-rd?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=3657567219942529703&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "35.6078943",
      "poi_longitude": "-97.5503319",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-755-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-c88682c2107b",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiYzghGscsocRp5rJBgJKwjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_89c2aff5-ad7a-4e06-a3d7-db1768942530",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Clark Crew BBQ",
      "poi_type": "Restaurants",
      "poi_address": "3510 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Casual establishment with a patio for pit-smoked beef brisket, ribs, pulled pork and more.",
      "poi_long_description": "Diners say this barbecue restaurant serves up delicious burnt ends, brisket, ribs, and sausage, with sides of mac and cheese, baked beans, and cornbread. They also highlight the friendly and attentive service, and the lively back patio with live music.\n\nSome reviews mention the parking can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-f29b-71c8-8c1d-feb4aaca9a62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-f29b-71c8-8c1d-feb4aaca9a62",
        "storage_key": "property/6767906449165580/019cfb37-f29b-71c8-8c1d-feb4aaca9a62.webp",
        "width": 599,
        "height": 596
      },
      "poi_business_url": "http://www.clarkcrewbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3587788996052338906&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clark-crew-bbq",
      "poi_latitude": "35.5323986",
      "poi_longitude": "-97.5816496",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-724-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-c88682c2107b",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6r6_-4asocR2kjBPhVjyjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_5680d0cf-b952-41f8-8f67-77eb7165c862",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Quail Springs Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Shopping destination with a cinema, a food court, a kids' play area, and an arcade.",
      "poi_long_description": "People say this shopping center offers a variety of stores, a food court, a movie theater, and an arcade. They also highlight the fun atmosphere, the clean environment, and the good prices for the arcade and movies.\n\nOther reviews mention the food court can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-f284-7389-b0d7-70c550a088cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-f284-7389-b0d7-70c550a088cb",
        "storage_key": "property/6767906449165580/019cfb37-f284-7389-b0d7-70c550a088cb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.quailspringsmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=254102542958583292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quail-springs-mall",
      "poi_latitude": "35.6130282",
      "poi_longitude": "-97.5584437",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-254-4979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08f0-76b8-88de-7735ef428505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08f0-76b8-88de-7735ef428505",
        "storage_key": "property/6767906449165580/019cfb38-08f0-76b8-88de-7735ef428505.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJS_2JfGccsocR_N2RoerAhgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_5cbfa134-a84c-4263-932a-4757d543ae92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "6409 Avondale Dr, Nichols Hills, OK 73116, USA",
      "poi_short_description": "Grocery chain featuring organic, gluten-free and vegan options, plus wine and flowers.",
      "poi_long_description": "People say this grocery store offers a wide selection of unique items, fresh produce, organic food, snacks, and wine. They highlight the affordable prices, good quality, and convenient pre-prepared meals. They also like the friendly staff and the pleasant, welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-f3ca-7109-b77e-c4de0eeea5a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-f3ca-7109-b77e-c4de0eeea5a5",
        "storage_key": "property/6767906449165580/019cfb37-f3ca-7109-b77e-c4de0eeea5a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/ok/nichols-hills/461/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6877173602117636080&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "35.5376946",
      "poi_longitude": "-97.5310595",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-843-5655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-ccf687ad6010.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-ccf687ad6010",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-ccf687ad6010.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIaTG8SUasocR8E_qTPSgcF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f85e73e0-325e-43bf-817a-6a7392a1d247",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6001 N Western Ave, Oklahoma City, OK 73118, USA",
      "poi_short_description": "Groceries, produce, artisan cheese and baked goods at a modern supermarket.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, meats, cheeses, and baked goods, including many organic and vegan options. They also highlight the friendly and helpful staff, and the clean and organized store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-f29c-72eb-b634-368302f56f94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-f29c-72eb-b634-368302f56f94",
        "storage_key": "property/6767906449165580/019cfb37-f29c-72eb-b634-368302f56f94.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/oklahomacity?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=551365353270644661&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "35.5340444",
      "poi_longitude": "-97.5305342",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-879-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-ccf687ad6010.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-ccf687ad6010",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-ccf687ad6010.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkeF-rCYasocRtY8nF97Xpgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_99c07eb2-b571-4430-a5f9-133da91ba305",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Crest Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "2200 W 15th St #124, Edmond, OK 73013, USA",
      "poi_short_description": "Supermarket featuring aisles of fresh groceries, baked goods and a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-f3a7-7297-b903-163bcf1f72f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-f3a7-7297-b903-163bcf1f72f2",
        "storage_key": "property/6767906449165580/019cfb37-f3a7-7297-b903-163bcf1f72f2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.crestfoodsok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9428274884093566538&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crest-foods",
      "poi_latitude": "35.6368691",
      "poi_longitude": "-97.5127608",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-330-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-ccf687ad6010.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-ccf687ad6010",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-ccf687ad6010.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVSeJIYgesocRSl4izw3214I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4a1fb179-e4fa-4162-acf4-8ec6b6b4c68f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "The Home Depot, 1901 S Broadway, Edmond, OK 73013, USA",
      "poi_short_description": "Home-improvement chain offering paint, tools, and building materials, plus installation services.",
      "poi_long_description": "People say this home improvement store has helpful and knowledgeable staff who are willing to assist with any task. They also highlight the friendly and efficient customer service, and the clean and well-stocked store.\n\nSome reviews mention the staff can be difficult to locate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-f28e-7142-a48f-e31144c0c9b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-f28e-7142-a48f-e31144c0c9b7",
        "storage_key": "property/6767906449165580/019cfb37-f28e-7142-a48f-e31144c0c9b7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Edmond/OK/Edmond/73013/3907?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5451913410994265011&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.6346297",
      "poi_longitude": "-97.4849931",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-330-0151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08f0-76b8-88de-7735ef428505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08f0-76b8-88de-7735ef428505",
        "storage_key": "property/6767906449165580/019cfb38-08f0-76b8-88de-7735ef428505.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9xQ7Wf4esocRs1uAoFwWqUs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_825e2839-2eab-4bbf-a458-b382b13b5330",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "University of Central Oklahoma",
      "poi_type": "Education",
      "poi_address": "100 N University Dr, Edmond, OK 73034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-f88b-706e-a4a0-3b9fecbd6e57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-f88b-706e-a4a0-3b9fecbd6e57",
        "storage_key": "property/6767906449165580/019cfb37-f88b-706e-a4a0-3b9fecbd6e57.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.uco.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17296425383341636856&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-central-oklahoma",
      "poi_latitude": "35.657506",
      "poi_longitude": "-97.4709491",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 405-974-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-d2f37ed2a502",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvZ0xm_BNr4cR-Lwg6j4_CfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b95dbd6c-bf98-46cd-9939-b983f8dfc54d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Oklahoma Christian University",
      "poi_type": "Education",
      "poi_address": "2501 E Memorial Rd, Edmond, OK 73013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-f8be-74bd-b3a1-f54b9527a2fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-f8be-74bd-b3a1-f54b9527a2fb",
        "storage_key": "property/6767906449165580/019cfb37-f8be-74bd-b3a1-f54b9527a2fb.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.oc.edu/?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=6907680163806340117&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-christian-university",
      "poi_latitude": "35.6126232",
      "poi_longitude": "-97.4697937",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-425-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-d2f37ed2a502",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN68XpyQfsocRFWSwsYIC3V8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_93329e59-18f3-4659-81bc-de20a628d511",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Edmond Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "10 S Blvd, Edmond, OK 73034, USA",
      "poi_short_description": "Popular, kid-friendly facility offering books for all ages, magazines, music, movies, programs, computers and toy areas.",
      "poi_long_description": "People say this public library offers a huge selection of books, including online audio and e-books through the Libby app. They highlight the convenient self-checkout system, the ability to reserve books online, and the calm and clean atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-f88e-7161-8c35-b58adadc60fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-f88e-7161-8c35-b58adadc60fe",
        "storage_key": "property/6767906449165580/019cfb37-f88e-7161-8c35-b58adadc60fe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=5308985467338173646&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edmond-library---metropolitan-library-system",
      "poi_latitude": "35.6542015",
      "poi_longitude": "-97.4778675",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-341-9282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-d2f37ed2a502",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ73psmrMfsocRzixngidOrUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_1db56250-cd09-4546-8c64-521fd0e458f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Blue Zoo Aquarium Oklahoma City",
      "poi_type": "Entertainment",
      "poi_address": "2501 W Memorial Rd Suite 125A, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Mall-based attraction featuring sharks, stingrays, snakes and other marine life plus a playground for kids.",
      "poi_long_description": "People say this aquarium offers a variety of interactive experiences, including stingray petting and feeding, bird feeding, and a mermaid show. They also highlight the family-friendly atmosphere, the friendly and helpful staff, and the fun play area for children.\n\nSome reviews mention the aquarium can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-f9c3-75fc-bce5-e7afa7ccecb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-f9c3-75fc-bce5-e7afa7ccecb6",
        "storage_key": "property/6767906449165580/019cfb37-f9c3-75fc-bce5-e7afa7ccecb6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://oklahomacity.bluezoo.us/?utm_source=google&utm_medium=organic&utm_campaign=Google+Business+Profile+-+OKC",
      "poi_directions_map_url": "https://maps.google.com/?cid=5242468447430833348&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blue-zoo-aquarium-oklahoma-city",
      "poi_latitude": "35.6125884",
      "poi_longitude": "-97.5573925",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 208-912-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-0903-7309-b131-679323bacdfd",
        "storage_key": "property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4zKmxcdsocRxPRO80b9wEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_26fbd36c-9e98-4aa6-aa25-694252d0e9ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Sky Zone",
      "poi_type": "Entertainment",
      "poi_address": "2525 S Broadway, Edmond, OK 73013, USA",
      "poi_short_description": "Children's entertainment center featuring indoor trampolines and other activities such as SkySlam basketball.",
      "poi_long_description": "People say this amusement park offers a fun trampoline park experience. They also highlight the friendly staff and management, and the clean and well-maintained facilities.\n\nOther reviews mention the price can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-f9ea-74b5-bd11-e37dd898bc4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-f9ea-74b5-bd11-e37dd898bc4c",
        "storage_key": "property/6767906449165580/019cfb37-f9ea-74b5-bd11-e37dd898bc4c.webp",
        "width": 1200,
        "height": 1200
      },
      "poi_business_url": "https://www.skyzone.com/edmond/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11100529412539313541&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone",
      "poi_latitude": "35.6300623",
      "poi_longitude": "-97.4862479",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-359-1631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-0903-7309-b131-679323bacdfd",
        "storage_key": "property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ75ZG2_wesocRhW0uBbAADZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_ef0bf7cc-3ae8-4995-b6b3-d514f0b3f802",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Chad Richison Stadium",
      "poi_type": "Entertainment",
      "poi_address": "100 E University Dr, Edmond, OK 73034, USA",
      "poi_short_description": "High school stadium hosting football games, including state championship events.",
      "poi_long_description": "People say this stadium offers a great experience for watching soccer games. They highlight the facilities are clean and well-maintained, and the sound system is top-notch. They also like the wide variety of concession options and the convenient credit card acceptance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-f9f7-77f9-924a-ef7fb61de12e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-f9f7-77f9-924a-ef7fb61de12e",
        "storage_key": "property/6767906449165580/019cfb37-f9f7-77f9-924a-ef7fb61de12e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://bronchosports.com/sports/2011/6/10/FB_0610111744.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=10132052462898693569&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chad-richison-stadium",
      "poi_latitude": "35.6615051",
      "poi_longitude": "-97.4707673",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-974-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0903-7309-b131-6b0143431a78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-0903-7309-b131-6b0143431a78",
        "storage_key": "property/6767906449165580/019cfb38-0903-7309-b131-6b0143431a78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhdKbbbcfsocRwcWyeAhInIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_3b66eda0-e51a-46bc-99f9-90935b83127b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Edmond History Museum",
      "poi_type": "Entertainment",
      "poi_address": "431 S Blvd, Edmond, OK 73034, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this museum offers a variety of displays and hands-on activities, especially for children. They highlight the fun role-play activities and the interesting local facts for adults. They also like the friendly staff and the free admission with the option of a gift shop and donation box.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-f9c0-7605-99b5-9e83c12fa704.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-f9c0-7605-99b5-9e83c12fa704",
        "storage_key": "property/6767906449165580/019cfb37-f9c0-7605-99b5-9e83c12fa704.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.edmondhistory.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=107138316684570186&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edmond-history-museum",
      "poi_latitude": "35.650103",
      "poi_longitude": "-97.4784",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-340-0078",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0909-73ca-9036-7ef0bdf2a935.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-0909-73ca-9036-7ef0bdf2a935",
        "storage_key": "property/6767906449165580/019cfb38-0909-73ca-9036-7ef0bdf2a935.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJy3Bcga0fsocRSi7RO7uhfAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6992020a-e4c4-462b-8f50-ebd6d7da88b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Dobson Field",
      "poi_type": "Entertainment",
      "poi_address": "Baird Loop, Edmond, OK 73013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-fb24-7556-bbe4-b633285aacca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-fb24-7556-bbe4-b633285aacca",
        "storage_key": "property/6767906449165580/019cfb37-fb24-7556-bbe4-b633285aacca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9132438859912438972&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dobson-field",
      "poi_latitude": "35.6139766",
      "poi_longitude": "-97.4731539",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0903-7309-b131-6b0143431a78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-0903-7309-b131-6b0143431a78",
        "storage_key": "property/6767906449165580/019cfb38-0903-7309-b131-6b0143431a78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn_Ha_3IfsocRvOQN4sHwvH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_2b96c87d-1b26-419b-b54c-f93aae79d313",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Mitch Park YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "2901 Marilyn Williams Dr, Edmond, OK 73003, USA",
      "poi_short_description": "Clean sports facility featuring a fitness center and an outdoor track, as well as an indoor pool, disc golf and basketball courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-f90b-757c-9069-5e4a467840a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-f90b-757c-9069-5e4a467840a1",
        "storage_key": "property/6767906449165580/019cfb37-f90b-757c-9069-5e4a467840a1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://ymcaokc.org/branches/mitch-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15994863836961186949&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mitch-park-ymca",
      "poi_latitude": "35.6847017",
      "poi_longitude": "-97.5083114",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-330-4016",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-0903-7309-b131-679323bacdfd",
        "storage_key": "property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-eeHJvT1sYcRhSTQUOor-d0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b231a74e-6d1f-43a8-ac51-52a4ff2e4fda",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "2563 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers excellent tennis courts. They also highlight the facility has many pools and pickleball courts.\n\nOther reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-f9b2-72fe-8df1-176b3f56a3d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-f9b2-72fe-8df1-176b3f56a3d4",
        "storage_key": "property/6767906449165580/019cfb37-f9b2-72fe-8df1-176b3f56a3d4.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/oklahoma-city.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=13614994550085944548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "35.61423510000001",
      "poi_longitude": "-97.5602129",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-832-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-0903-7309-b131-679323bacdfd",
        "storage_key": "property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWAnM3kdsocR5ITAcGgt8rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b5189f8a-dd8d-48d2-b7cd-647d6ff1e000",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Crunch Fitness - Oklahoma City, OK",
      "poi_type": "Health and Wellness",
      "poi_address": "12508 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Gym, part of a chain, offering yoga, cardio and weights rooms, and tanning beds.",
      "poi_long_description": "People say this gym offers a wide variety of group fitness classes, modern equipment, and childcare, and has a friendly and motivating atmosphere.\n\nOther reviews mention membership cancellation can be difficult and there can be hidden fees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-fcfa-762a-8032-da63e412e475.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-fcfa-762a-8032-da63e412e475",
        "storage_key": "property/6767906449165580/019cfb37-fcfa-762a-8032-da63e412e475.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/quail-springs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097941148085874568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---oklahoma-city-ok",
      "poi_latitude": "35.5969373",
      "poi_longitude": "-97.565988",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-497-8160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-0903-7309-b131-679323bacdfd",
        "storage_key": "property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Z8NgOkdsocRiG_leCo9oFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5d75d05c-46c3-410f-935b-785789caf831",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Oklahoma Gold Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "3001 Technology Dr, Edmond, OK 73013, USA",
      "poi_short_description": "Gym for kids offering classes in gymnastics and tumbling, plus birthday parties.",
      "poi_long_description": "People say this gymnastics center offers fun classes and birthday parties for young children. They highlight the positive and encouraging atmosphere, and the confidence children gain. They also like the kind, welcoming, and dedicated staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-fd65-770b-b1a4-15754325adc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-fd65-770b-b1a4-15754325adc9",
        "storage_key": "property/6767906449165580/019cfb37-fd65-770b-b1a4-15754325adc9.webp",
        "width": 1280,
        "height": 775
      },
      "poi_business_url": "http://www.oklahomagoldgymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=191096937127623553&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-gold-gymnastics",
      "poi_latitude": "35.6263031",
      "poi_longitude": "-97.4926773",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-341-1175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-d2f37ed2a502",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw7GpO_AesocRgTso36bppgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_450c8b77-3157-409b-a8a0-c87aa45d12d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Crunch Fitness - Edmond",
      "poi_type": "Health and Wellness",
      "poi_address": "2121 W Danforth Rd, Edmond, OK 73003, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, cardio machines, and powerlifting stations, and has a spacious layout with an outdoor workout area.\n\nOther reviews mention the restrooms can be poorly maintained and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-fd56-775b-a36e-d9a982ebde2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-fd56-775b-a36e-d9a982ebde2f",
        "storage_key": "property/6767906449165580/019cfb37-fd56-775b-a36e-d9a982ebde2f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/edmond",
      "poi_directions_map_url": "https://maps.google.com/?cid=8462207099918585172&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---edmond",
      "poi_latitude": "35.6692665",
      "poi_longitude": "-97.5106805",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-920-1940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-0903-7309-b131-679323bacdfd",
        "storage_key": "property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo1bUEHcfsocRVI1vzoXMb3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_426bc5a7-967c-4572-b516-5e5f53affa35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2209 W Edmond Rd, Edmond, OK 73003, USA",
      "poi_short_description": "Laid-back fitness center featuring workout machines plus massage chairs and tanning beds.",
      "poi_long_description": "People say this gym offers a good selection of equipment and machines, including free weights and tanning beds. They highlight the clean and tidy facility, and the convenient location and hours. They also like the friendly and helpful staff, and the welcoming and non-judgmental atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-fd65-770b-b1a4-18d82be1c268.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-fd65-770b-b1a4-18d82be1c268",
        "storage_key": "property/6767906449165580/019cfb37-fd65-770b-b1a4-18d82be1c268.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/edmond-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=12798186502624872755&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.6543154",
      "poi_longitude": "-97.5129943",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-697-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-0903-7309-b131-679323bacdfd",
        "storage_key": "property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu4H7420esocRM4knAtFKnLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_16356e7b-35ca-4755-a4e5-4ed3d6e87b81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "TB Fitness Club",
      "poi_type": "Health and Wellness",
      "poi_address": "3333 W Hefner Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-feaa-769e-bbcf-bf4926533e13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-feaa-769e-bbcf-bf4926533e13",
        "storage_key": "property/6767906449165580/019cfb37-feaa-769e-bbcf-bf4926533e13.webp",
        "width": 1280,
        "height": 730
      },
      "poi_business_url": "https://tbfitclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12558554567901756546&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tb-fitness-club",
      "poi_latitude": "35.5816564",
      "poi_longitude": "-97.5782735",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-849-9173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-0903-7309-b131-679323bacdfd",
        "storage_key": "property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSfqhdqYbsocRgrwkaNfySK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_caf44975-4f94-4c22-9090-5f2c90f7ae68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Metro Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "7420 Broadway Ext, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Gymnastics center offering classes and birthday parties for kids of various ages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-fe5c-7346-a5f1-122afdd92745.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-fe5c-7346-a5f1-122afdd92745",
        "storage_key": "property/6767906449165580/019cfb37-fe5c-7346-a5f1-122afdd92745.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metrogymokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3312655711320854520&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "metro-gymnastics",
      "poi_latitude": "35.5464292",
      "poi_longitude": "-97.5132581",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-848-5308",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-d2f37ed2a502",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSXSRwJwZsocR-M9yeNHq-C0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_04a2db24-6952-4025-a6eb-8cc612e8f05a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "2340 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Beauty retailer offering cosmetics, fragrances, and skin and hair care products, plus salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-fe51-757c-b913-366dc976889f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-fe51-757c-b913-366dc976889f",
        "storage_key": "property/6767906449165580/019cfb37-fe51-757c-b913-366dc976889f.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/oklahoma-city-ok-128",
      "poi_directions_map_url": "https://maps.google.com/?cid=17751417342740012859&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "35.606929",
      "poi_longitude": "-97.553605",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-302-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-0903-7309-b131-679323bacdfd",
        "storage_key": "property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmaQHR2kcsocROx-6rQW0WfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_64136bd2-9bc2-4729-83ea-c01643664808",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Mercy Hospital Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "4300 W Memorial Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-fe6b-73b7-aed9-d9c6c8fb9c30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-fe6b-73b7-aed9-d9c6c8fb9c30",
        "storage_key": "property/6767906449165580/019cfb37-fe6b-73b7-aed9-d9c6c8fb9c30.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mercy.net/practice/mercy-hospital-oklahoma-city?utm_source=google&utm_medium=organic_search&utm_campaign=yext&utm_term=West&utm_content=website&y_source=1_MTI5OTY2MDItNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=9313836111055257082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercy-hospital-oklahoma-city",
      "poi_latitude": "35.607198",
      "poi_longitude": "-97.600529",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-755-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08f2-730f-8b79-5dd496f1a0b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08f2-730f-8b79-5dd496f1a0b5",
        "storage_key": "property/6767906449165580/019cfb38-08f2-730f-8b79-5dd496f1a0b5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE-YSHLkcsocR-n2nn5hkQYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_6f5aa76b-f064-4d94-9edf-0f9c033852b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Oklahoma Heart Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4050 W Memorial Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-fe6a-764f-aecd-b0bf3735a981.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-fe6a-764f-aecd-b0bf3735a981",
        "storage_key": "property/6767906449165580/019cfb37-fe6a-764f-aecd-b0bf3735a981.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.okheart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7955518146030748896&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-heart-hospital",
      "poi_latitude": "35.6075318",
      "poi_longitude": "-97.5969115",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-608-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08f2-730f-8b79-5dd496f1a0b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08f2-730f-8b79-5dd496f1a0b5",
        "storage_key": "property/6767906449165580/019cfb38-08f2-730f-8b79-5dd496f1a0b5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJW8z9OL8csocR4ERWipqtZ24",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0aa818d8-d7eb-4efa-872b-db6671ad3b72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Martin Park Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5000 W Memorial Rd, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Kid-friendly nature preserve with playgrounds and trails, plus deer and turtles.",
      "poi_long_description": "People say this park offers beautiful trails, a playground, and opportunities to see wildlife like deer, turtles, and birds. They highlight the serene and peaceful atmosphere, and the well-maintained grounds. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0119-72d2-a3dd-62d587ef2fd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb38-0119-72d2-a3dd-62d587ef2fd4",
        "storage_key": "property/6767906449165580/019cfb38-0119-72d2-a3dd-62d587ef2fd4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation/martin-park-nature-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9715724291787303274&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martin-park-nature-center",
      "poi_latitude": "35.6090059",
      "poi_longitude": "-97.6090052",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-297-1429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08f0-76b8-88de-73a156571349.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08f0-76b8-88de-73a156571349",
        "storage_key": "property/6767906449165580/019cfb38-08f0-76b8-88de-73a156571349.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ71CwarQcsocRaqmda8Qv1YY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_294b06a7-7d0d-43db-9cc2-114697e6a875",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Stars And Stripes Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3701 S Lake Hefner Dr, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Relaxed, family-friendly park bordering Lake Hefner offering a skatepark, plus playgrounds.",
      "poi_long_description": "People say this city park offers a large playground, walking trails, and panoramic views of the lake. They highlight the numerous play areas, tables, and BBQ spaces, as well as the decent parking and proximity to the lake. They also like the ability to build sandcastles and watch boats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0366-72e3-9d49-ebb53f90b3ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb38-0366-72e3-9d49-ebb53f90b3ba",
        "storage_key": "property/6767906449165580/019cfb38-0366-72e3-9d49-ebb53f90b3ba.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/34/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=16012526237037472583&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stars-and-stripes-park",
      "poi_latitude": "35.5500436",
      "poi_longitude": "-97.5822759",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08f0-76b8-88de-73a156571349.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08f0-76b8-88de-73a156571349",
        "storage_key": "property/6767906449165580/019cfb38-08f0-76b8-88de-73a156571349.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2tmaBwbsocRR6s9S8brN94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4352d9a5-8925-4a5f-a8da-e057faf75b78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Bluff Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11301 N Meridian Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "A large green space featuring walking trails, picnic spots and a playground.",
      "poi_long_description": "Visitors say this park offers well-maintained walking trails, paved trails, and bike trails, and they praise the abundance of wildlife, especially deer. They also highlight the peaceful atmosphere, ideal for nature walks, jogging, or simply relaxing in the outdoors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0224-7593-ae66-4a10e7b9c52d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb38-0224-7593-ae66-4a10e7b9c52d",
        "storage_key": "property/6767906449165580/019cfb38-0224-7593-ae66-4a10e7b9c52d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/8/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=1559565554729670411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluff-creek-park",
      "poi_latitude": "35.584442",
      "poi_longitude": "-97.6065873",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-837-7995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08f0-76b8-88de-73a156571349.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08f0-76b8-88de-73a156571349",
        "storage_key": "property/6767906449165580/019cfb38-08f0-76b8-88de-73a156571349.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh3zaRlYbsocRC9eY7ZuwpBU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_42e0fd28-724f-4b98-9757-1ab750b4a2f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "E.C. Hafer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1034 S Bryant Ave, Edmond, OK 73034, USA",
      "poi_short_description": "Large park with duck ponds and a variety of playground equipment.",
      "poi_long_description": "Visitors say this park offers a paved walking trail, playgrounds, picnic tables, pavilions, a sand volleyball court, workout stations, and a duck pond. They also highlight the scenic views, abundance of trees, and family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-03b9-7162-9f2e-26886837245d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb38-03b9-7162-9f2e-26886837245d",
        "storage_key": "property/6767906449165580/019cfb38-03b9-7162-9f2e-26886837245d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://edmondok.com/facilities/Facility/Details/9",
      "poi_directions_map_url": "https://maps.google.com/?cid=2633511566572246196&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ec-hafer-park",
      "poi_latitude": "35.6428821",
      "poi_longitude": "-97.4551926",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-359-4630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08f0-76b8-88de-73a156571349.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08f0-76b8-88de-73a156571349",
        "storage_key": "property/6767906449165580/019cfb38-08f0-76b8-88de-73a156571349.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJOa4APJ4fsocRtNRrHdEcjCQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c42f1418-ff1e-48f9-90be-c14ba83511e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Rose Creek Country Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17031 N May Ave, Edmond, OK 73012, USA",
      "poi_short_description": "Private golf course with an on-site eatery, pickleball courts, a clubhouse and a patio.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0378-7038-91f9-bf3026500e9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb38-0378-7038-91f9-bf3026500e9c",
        "storage_key": "property/6767906449165580/019cfb38-0378-7038-91f9-bf3026500e9c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rosecreekgc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14897560691660009268&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rose-creek-country-club",
      "poi_latitude": "35.6449907",
      "poi_longitude": "-97.5686808",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-330-8220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0906-70a7-a6a9-69dcdf51c76e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-0906-70a7-a6a9-69dcdf51c76e",
        "storage_key": "property/6767906449165580/019cfb38-0906-70a7-a6a9-69dcdf51c76e.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJh8IOAwgdsocRNK83toTEvs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_05020735-ab09-4c7b-b17c-b3709238c71e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Costco Member Service Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14501 Bogert Pkwy, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-04e1-732e-af56-d3e5bab2c265.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb38-04e1-732e-af56-d3e5bab2c265",
        "storage_key": "property/6767906449165580/019cfb38-04e1-732e-af56-d3e5bab2c265.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3497496067160567460&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "costco-member-service-center",
      "poi_latitude": "35.6183037",
      "poi_longitude": "-97.5748651",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-0903-7309-b131-679323bacdfd",
        "storage_key": "property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX18i7nkdsocRpG5ufiSaiTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_517ea9bb-c14e-4d22-82bb-eb682e2dab01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Chesapeake Energy Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6100 N Western Ave, Oklahoma City, OK 73116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-04b2-763b-835d-187a21dccce9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb38-04b2-763b-835d-187a21dccce9",
        "storage_key": "property/6767906449165580/019cfb38-04b2-763b-835d-187a21dccce9.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.expandenergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3999976576566005612&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chesapeake-energy-corporation",
      "poi_latitude": "35.5346273",
      "poi_longitude": "-97.5289016",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-848-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-0903-7309-b131-679323bacdfd",
        "storage_key": "property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN8cjlSYasocRbI8Z7IDFgjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_99204ff5-3b6f-4269-a410-ab2d54e66713",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Love's South Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2101 Vineyard Blvd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-04ad-7743-862f-99b755c0b678.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb38-04ad-7743-862f-99b755c0b678",
        "storage_key": "property/6767906449165580/019cfb38-04ad-7743-862f-99b755c0b678.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4360911662846330364&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-south-building",
      "poi_latitude": "35.5769306",
      "poi_longitude": "-97.5501889",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-0903-7309-b131-679323bacdfd",
        "storage_key": "property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfjgpJsbsocR_EXQYA0ShTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e7b02b6c-c14a-435b-82a2-8b14f39d94d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Love's Corporate - Building 50",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3601 NW 63rd St, Oklahoma City, OK 73116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-04c6-7675-b03a-83262718ee94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb38-04c6-7675-b03a-83262718ee94",
        "storage_key": "property/6767906449165580/019cfb38-04c6-7675-b03a-83262718ee94.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4599439798442847940&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-corporate---building-50",
      "poi_latitude": "35.5374849",
      "poi_longitude": "-97.5809021",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-0903-7309-b131-679323bacdfd",
        "storage_key": "property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw8bq4uQasocRxO76tyB-1D8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_addd3494-7ad5-46cd-971a-0b03518ff62b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Love's Corporate - Contact Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1331 W Memorial Rd Suite 100, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-04b9-71e9-9a09-4c84d76b8416.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb38-04b9-71e9-9a09-4c84d76b8416",
        "storage_key": "property/6767906449165580/019cfb38-04b9-71e9-9a09-4c84d76b8416.webp",
        "width": 1280,
        "height": 830
      },
      "poi_business_url": "http://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4980310977560095404&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-corporate---contact-center",
      "poi_latitude": "35.61081310000001",
      "poi_longitude": "-97.5351028",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-0903-7309-b131-679323bacdfd",
        "storage_key": "property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKbub2xkcsocRrKpygHKeHUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e939969d-e552-41ce-8aa0-4d3375a08a75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Angie Debo Elementary School",
      "poi_type": "Education",
      "poi_address": "16060 N May Ave, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-a954-775a-a65d-6ccaf2508575.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-a954-775a-a65d-6ccaf2508575",
        "storage_key": "property/6767906449165580/019d7911-a954-775a-a65d-6ccaf2508575.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://angiedebo.edmondschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3747134273898061372&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "angie-debo-elementary-school",
      "poi_latitude": "35.6331181",
      "poi_longitude": "-97.5653563",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-340-2270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-d2f37ed2a502",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJTeUdlUcsocRPJ5i2cR-ADQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_9e4aaaac-05f0-484a-a384-9f523eac8d0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Deer Creek Elementary",
      "poi_type": "Education",
      "poi_address": "4704 NW 164th St, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-aa61-7432-9b06-df52bc0f34df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-aa61-7432-9b06-df52bc0f34df",
        "storage_key": "property/6767906449165580/019d7911-aa61-7432-9b06-df52bc0f34df.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://dce.deercreekschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13570460144324592830&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "deer-creek-elementary",
      "poi_latitude": "35.6372514",
      "poi_longitude": "-97.6063129",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-348-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-d2f37ed2a502",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJC_r5Hy8dsocRvkQQFZr1U7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f997e835-8eec-4974-9018-f7fce7583e07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Summit Middle School",
      "poi_type": "Education",
      "poi_address": "1703 NW 150th St, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-ab3d-711f-a77d-686eb270cd46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ab3d-711f-a77d-686eb270cd46",
        "storage_key": "property/6767906449165580/019d7911-ab3d-711f-a77d-686eb270cd46.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://summit.edmondschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4052681169359623432&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "summit-middle-school",
      "poi_latitude": "35.625296",
      "poi_longitude": "-97.5414836",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-340-2920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-d2f37ed2a502",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJueUCwjkcsocRCFWYLw0EPjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_c998fefd-d5f8-4c17-b95b-1ce809055f44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Cimarron Middle School",
      "poi_type": "Education",
      "poi_address": "3701 S Bryant Ave, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-b144-752b-9073-e3edad52ce59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b144-752b-9073-e3edad52ce59",
        "storage_key": "property/6767906449165580/019d7911-b144-752b-9073-e3edad52ce59.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://cimarron.edmondschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14977112001491695191&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cimarron-middle-school",
      "poi_latitude": "35.6193426",
      "poi_longitude": "-97.4618711",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-340-2935",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-d2f37ed2a502",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtzcgRhUfsocRV_YmYgNk2c8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_fa362e0b-b9b4-4196-b3e4-3e300e12a206",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Edmond Santa Fe High School",
      "poi_type": "Education",
      "poi_address": "1901 W 15th St, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-b383-75e7-be3e-8bd83be9ad3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b383-75e7-be3e-8bd83be9ad3a",
        "storage_key": "property/6767906449165580/019d7911-b383-75e7-be3e-8bd83be9ad3a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://santafe.edmondschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3158354544559100067&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "edmond-santa-fe-high-school",
      "poi_latitude": "35.6401779",
      "poi_longitude": "-97.5088169",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-340-2230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-d2f37ed2a502",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPS_GbGIesocRo5Avf7m61Cs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_37b1142a-870a-4a24-9718-8ca6cff6b0b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "John Marshall High School",
      "poi_type": "Education",
      "poi_address": "12201 Portland Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-b275-7772-9269-18817124a57b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b275-7772-9269-18817124a57b",
        "storage_key": "property/6767906449165580/019d7911-b275-7772-9269-18817124a57b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okcps.org/Johnmarshall",
      "poi_directions_map_url": "https://maps.google.com/?cid=13761330892857833865&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "john-marshall-high-school",
      "poi_latitude": "35.5932637",
      "poi_longitude": "-97.5882344",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-587-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-d2f37ed2a502",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnV-lOJ8csocRiXlmUYkR-r4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_2eeb4f22-34c0-4101-8608-3c7d022484f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Heritage Hall",
      "poi_type": "Education",
      "poi_address": "1800 NW 122nd St, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-b787-7533-ad7d-a7e4a5300c67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b787-7533-ad7d-a7e4a5300c67",
        "storage_key": "property/6767906449165580/019d7911-b787-7533-ad7d-a7e4a5300c67.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.heritagehall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7233749162249664118&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "heritage-hall",
      "poi_latitude": "35.591122",
      "poi_longitude": "-97.542737",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-749-3001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-d2f37ed2a502",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp_UYSwgcsocRdrYreolwY2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_6be87e62-e19d-4c5d-97f4-06183ed90ece",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Mercy School Institute",
      "poi_type": "Education",
      "poi_address": "14001 N Harvey Ave, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-bb3c-713d-a550-e90aef0a46fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-bb3c-713d-a550-e90aef0a46fe",
        "storage_key": "property/6767906449165580/019d7911-bb3c-713d-a550-e90aef0a46fe.webp",
        "width": 960,
        "height": 639
      },
      "poi_business_url": "http://www.mercyschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11702466736219190867&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mercy-school-institute",
      "poi_latitude": "35.6127046",
      "poi_longitude": "-97.5190585",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-748-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-d2f37ed2a502",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-d2f37ed2a502.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEZOm26MesocRU3YriH6DZ6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_90221fa1-e2fa-4fc1-893f-049797428d6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Cafe 7",
      "poi_type": "Restaurants",
      "poi_address": "14101 N May Ave #117, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Casual Italian eatery providing specialty & design-your-own pizzas, pastas, sandwiches & salads.",
      "poi_long_description": "People say this Italian restaurant serves delicious pizza, sandwiches, and pasta dishes, with options for customization. They highlight the reasonable prices and the clean, cozy environment. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-c5d3-7400-b20c-3fdf7cc62595.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c5d3-7400-b20c-3fdf7cc62595",
        "storage_key": "property/6767906449165580/019d7911-c5d3-7400-b20c-3fdf7cc62595.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://cafe7okc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9503759449688436741&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cafe-7",
      "poi_latitude": "35.61495180000001",
      "poi_longitude": "-97.5679744",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-748-3354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-c88682c2107b",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH78eiV8csocRBfBwzd0i5IM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_a5b4100a-aded-49dc-8f1b-af118f9e34b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Red Lobster",
      "poi_type": "Restaurants",
      "poi_address": "2625 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Family-friendly seafood restaurant offering comfort food in a casual setting.",
      "poi_long_description": "People say this seafood restaurant serves delicious lobster, shrimp, and seafood boils. They also highlight the attentive and friendly staff, and the clean atmosphere.\n\nOther reviews mention the food can be salty.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-c840-73b7-ac13-0175a5d32f14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c840-73b7-ac13-0175a5d32f14",
        "storage_key": "property/6767906449165580/019d7911-c840-73b7-ac13-0175a5d32f14.webp",
        "width": 1280,
        "height": 725
      },
      "poi_business_url": "https://www.redlobster.com/seafood-restaurants/locations/ok/oklahoma-city/2625-w-memorial-rd/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2374089157655298518&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "red-lobster",
      "poi_latitude": "35.6103",
      "poi_longitude": "-97.561909",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-755-1390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-c88682c2107b",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFeEtJmccsocR1oEmq4J18iA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_1f1b9675-b52c-443f-ba1c-9e5de1a197e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2639 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Diners say this Italian restaurant serves delicious breadsticks and salad, with many enjoying the pasta and large portions. They also highlight the attentive service and clean atmosphere.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-c5e5-7208-9ad3-7e9fc28ccc63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c5e5-7208-9ad3-7e9fc28ccc63",
        "storage_key": "property/6767906449165580/019d7911-c5e5-7208-9ad3-7e9fc28ccc63.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.olivegarden.com/locations/ok/oklahoma-city/okc-quail-springs/1307?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:oklahoma-city-ok-1307_pl:locurl_rd:1232",
      "poi_directions_map_url": "https://maps.google.com/?cid=8219669357692290620&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "35.610316",
      "poi_longitude": "-97.56239",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-749-8188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-c88682c2107b",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw2vU12YcsocRPIZpLLshEnI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_ee61551e-65c6-4ba3-810c-fb84a894449b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Five Guys",
      "poi_type": "Restaurants",
      "poi_address": "2300 W Memorial Rd Suite 160, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Fast-food chain with made-to-order burgers, fries & hot dogs, plus free peanuts while you wait.",
      "poi_long_description": "People say this fast food restaurant serves delicious burgers and fresh fries. They also highlight the generous portions and the ability to customize orders.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-c7c8-77f9-846c-9d329ffc1b21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c7c8-77f9-846c-9d329ffc1b21",
        "storage_key": "property/6767906449165580/019d7911-c7c8-77f9-846c-9d329ffc1b21.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://restaurants.fiveguys.com/2300-w-memorial-road",
      "poi_directions_map_url": "https://maps.google.com/?cid=7548486369241485367&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "five-guys",
      "poi_latitude": "35.607968",
      "poi_longitude": "-97.553055",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-753-4554",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-c88682c2107b",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS9Sd4mscsocRN1CE9lucwWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_db6f687c-c5e0-482f-9c58-8012d66d1656",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Crumbl",
      "poi_type": "Restaurants",
      "poi_address": "13004 N Pennsylvania Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Bakeshop chain offering oversized cookies, delivery and curbside pickup.",
      "poi_long_description": "People say this dessert shop offers delicious cookies with creative flavors and beautiful presentation. They highlight the fast service, friendly staff, and clean store. They also like the easy-to-use app and the weekly rotating menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-d52d-7399-bde9-31698edab615.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d52d-7399-bde9-31698edab615",
        "storage_key": "property/6767906449165580/019d7911-d52d-7399-bde9-31698edab615.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://crumblcookies.com/stores/ok/oklahoma-city-area/okchisholmcreek",
      "poi_directions_map_url": "https://maps.google.com/?cid=13617714539835960114&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "crumbl",
      "poi_latitude": "35.6023588",
      "poi_longitude": "-97.549",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-463-1802",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-c88682c2107b",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYwj36GMdsocRMiuYZznX-7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_3cf53e2b-9c18-4b14-93f1-032f35d72728",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "13601 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "People say this coffee shop has a convenient drive-thru and offers popular drinks like chai tea and pink drinks. They also highlight the friendly staff and efficient service.\n\nSome reviews mention the drinks can be made incorrectly.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-d811-762c-be1a-7adcb9f4f4f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d811-762c-be1a-7adcb9f4f4f9",
        "storage_key": "property/6767906449165580/019d7911-d811-762c-be1a-7adcb9f4f4f9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starbucks.ca/store-locator/store/1030994/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2217484800767464764&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "35.60814",
      "poi_longitude": "-97.56787",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-754-1023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7912-1c02-74b8-822f-8a544258b5c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-1c02-74b8-822f-8a544258b5c2",
        "storage_key": "property/6767906449165580/019d7912-1c02-74b8-822f-8a544258b5c2.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ-RQ2vXEdsocRPJWSdK0Wxh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_638467a9-a473-406d-8807-68092f709ea3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2501 W Memorial Rd Suite 12, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-de00-7406-b604-090dd3d6306e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-de00-7406-b604-090dd3d6306e",
        "storage_key": "property/6767906449165580/019d7911-de00-7406-b604-090dd3d6306e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/quail-springs-mall?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15773812260357346319&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "35.612914",
      "poi_longitude": "-97.5586682",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-755-4762",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-c88682c2107b",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvaQTZ2ccsocRDxRNdK3W59o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_815487a9-d434-4607-b67c-6f8533b0d777",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "14221 N Pennsylvania Ave, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "People say this Mexican restaurant offers burritos, bowls, and tacos.\n\nOther reviews mention the food can be inconsistent and the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-df1c-75c7-824e-61c8af2da225.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-df1c-75c7-824e-61c8af2da225",
        "storage_key": "property/6767906449165580/019d7911-df1c-75c7-824e-61c8af2da225.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.chipotle.com/ok/oklahoma-city/14221-n-pennsylvania-ave?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=2169",
      "poi_directions_map_url": "https://maps.google.com/?cid=12087686342609737433&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "35.61487",
      "poi_longitude": "-97.5500671",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-302-4903",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-c88682c2107b",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy-o1uUEcsocR2RaYb68WwKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_af7161ad-fda2-450d-b44f-3886203d36a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Panang 2 Thai Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "14101 N May Ave #109, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Unfussy, family-owned option for hearty portions of familiar fare such as curries & stir-fries.",
      "poi_long_description": "People say this Thai restaurant serves delicious lunch specials with ample portions. They also highlight the fast service and friendly staff.\n\nOther reviews mention the food can be spicy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-e36d-7218-9b1f-97d35ec6ab70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e36d-7218-9b1f-97d35ec6ab70",
        "storage_key": "property/6767906449165580/019d7911-e36d-7218-9b1f-97d35ec6ab70.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://panangthaifood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9789529750388181657&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "panang-2-thai-restaurant",
      "poi_latitude": "35.614502",
      "poi_longitude": "-97.56789",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-752-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08fc-726b-bf19-c88682c2107b",
        "storage_key": "property/6767906449165580/019cfb38-08fc-726b-bf19-c88682c2107b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH78eiV8csocRmYoB2nBl24c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_119610ae-dc8b-4e21-9211-2b19a3417522",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Target Mobile",
      "poi_type": "Shopping & Retail",
      "poi_address": "13924 N Pennsylvania Ave, Oklahoma City, OK 73134, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-ef59-776d-a889-8dcd2ed0f651.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ef59-776d-a889-8dcd2ed0f651",
        "storage_key": "property/6767906449165580/019d7911-ef59-776d-a889-8dcd2ed0f651.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.target.com/mobile",
      "poi_directions_map_url": "https://maps.google.com/?cid=7523990430698125957&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target-mobile",
      "poi_latitude": "35.6125122",
      "poi_longitude": "-97.5468412",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-752-0183",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08f0-76b8-88de-7735ef428505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08f0-76b8-88de-7735ef428505",
        "storage_key": "property/6767906449165580/019cfb38-08f0-76b8-88de-7735ef428505.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJe5CavWocsocRhToz026Vamg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cell_phone_store"
    },
    {
      "id": "custom_83d77bbd-6c0b-44ad-bdae-486ae4fa10c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2000 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Department store carrying a wide range of merchandise, including electronics, home appliances, and groceries.",
      "poi_long_description": "People say this department store offers a wide variety of products, including groceries, home goods, and electronics, and provides convenient services like delivery and online pickup.\n\nOther reviews mention the service can be slow and the store can be understaffed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-f27f-76f8-bb35-f42b3a4cfd1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f27f-76f8-bb35-f42b3a4cfd1a",
        "storage_key": "property/6767906449165580/019d7911-f27f-76f8-bb35-f42b3a4cfd1a.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1626-oklahoma-city-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=10140810101618845328&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.6052952",
      "poi_longitude": "-97.5460685",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-752-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08f0-76b8-88de-7735ef428505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08f0-76b8-88de-7735ef428505",
        "storage_key": "property/6767906449165580/019cfb38-08f0-76b8-88de-7735ef428505.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-WNQUWscsocRkCavIQ9lu4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_afe4e0a9-9cad-4ced-a2bc-2dbf110a3a5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Hobby Lobby",
      "poi_type": "Shopping & Retail",
      "poi_address": "2201 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Chain carrying a variety of arts & crafts materials, plus party supplies, fabric & home-decor items.",
      "poi_long_description": "People say this craft store offers a wide variety of seasonal decorations, DIY supplies, and jewelry-making materials. They highlight the great deals, especially during sales, and the well-stocked shelves. They also like the helpful and responsive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-f8f7-7209-b151-616a16bedef1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f8f7-7209-b151-616a16bedef1",
        "storage_key": "property/6767906449165580/019d7911-f8f7-7209-b151-616a16bedef1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hobbylobby.com/stores/search/124",
      "poi_directions_map_url": "https://maps.google.com/?cid=9419838112277096680&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hobby-lobby",
      "poi_latitude": "35.6110267",
      "poi_longitude": "-97.5521011",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-753-9417",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08f0-76b8-88de-7735ef428505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08f0-76b8-88de-7735ef428505",
        "storage_key": "property/6767906449165580/019cfb38-08f0-76b8-88de-7735ef428505.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ72uN-WkcsocR6Gj2y9r8uYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_4bbaa507-7494-4d70-9885-978a89c74bd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "DICK'S Sporting Goods",
      "poi_type": "Shopping & Retail",
      "poi_address": "6601 SW 3rd St, Oklahoma City, OK 73128, USA",
      "poi_short_description": "Sporting goods chain with equipment, apparel & footwear for athletics, outdoor recreation & fitness.",
      "poi_long_description": "People say this sporting goods store offers a wide selection of kayaks and other sporting goods.\n\nOther reviews mention the service can be slow and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-fcaf-71b4-a37e-49b5e4dc76e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-fcaf-71b4-a37e-49b5e4dc76e1",
        "storage_key": "property/6767906449165580/019d7911-fcaf-71b4-a37e-49b5e4dc76e1.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://stores.dickssportinggoods.com/ok/oklahoma-city/1081/?seo=localpack",
      "poi_directions_map_url": "https://maps.google.com/?cid=6326265602649391218&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dick-s-sporting-goods",
      "poi_latitude": "35.4633371",
      "poi_longitude": "-97.6297484",
      "poi_miles_from_property": "14.8 mi",
      "poi_walking_minutes": "5 hours 31 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 405-491-2570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08f0-76b8-88de-7735ef428505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08f0-76b8-88de-7735ef428505",
        "storage_key": "property/6767906449165580/019cfb38-08f0-76b8-88de-7735ef428505.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJmSzV97YPsocRcoCwMAxpy1c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_667ad2ca-5c76-47f8-8b43-96e25dd4ff16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Home Depot Quail Springs",
      "poi_type": "Shopping & Retail",
      "poi_address": "HomeDepot, Quail Spgs Pkwy, Oklahoma City, OK 73134, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13414236101787886611&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "home-depot-quail-springs",
      "poi_latitude": "35.6137378",
      "poi_longitude": "-97.5594162",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08f0-76b8-88de-7735ef428505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08f0-76b8-88de-7735ef428505",
        "storage_key": "property/6767906449165580/019cfb38-08f0-76b8-88de-7735ef428505.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJs3VnNAAdsocRE6RJtKnwKLo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hardware_store"
    },
    {
      "id": "custom_3ae05935-af8b-4312-bae7-42ea31f4fdf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "2350 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "People say this clothing store offers a wide variety of clothing, shoes, and home decor. They also highlight the affordable prices and the helpful staff.\n\nSome reviews mention the store can be messy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7911-fcb3-76ca-be15-0db5c4b072b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-fcb3-76ca-be15-0db5c4b072b9",
        "storage_key": "property/6767906449165580/019d7911-fcb3-76ca-be15-0db5c4b072b9.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=694027355670400107&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "35.6068477",
      "poi_longitude": "-97.5540911",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-749-0831",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08f0-76b8-88de-7735ef428505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08f0-76b8-88de-7735ef428505",
        "storage_key": "property/6767906449165580/019cfb38-08f0-76b8-88de-7735ef428505.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJF3ICOWkcsocRa0wj7zOuoQk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_7f416f29-eb1f-41c6-a213-b3cf7453339e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2135 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "People say this electronics store offers a wide selection of products, including TVs, laptops, and gaming consoles. They also highlight the helpful and friendly staff, and the organized and clean setup.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7912-01fe-7398-b51b-e13e34d0b451.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-01fe-7398-b51b-e13e34d0b451",
        "storage_key": "property/6767906449165580/019d7912-01fe-7398-b51b-e13e34d0b451.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://stores.bestbuy.com/ok/oklahoma-city/2135-w-memorial-rd-646.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=16511127423653645530&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "35.611093",
      "poi_longitude": "-97.55148",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-752-0295",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08f0-76b8-88de-7735ef428505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08f0-76b8-88de-7735ef428505",
        "storage_key": "property/6767906449165580/019cfb38-08f0-76b8-88de-7735ef428505.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5x91LGocsocR2gwWgOlOI-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_0619f6a1-9e41-4007-9ad2-30d6b66f6764",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Sam's Club Gas Station",
      "poi_type": "Shopping & Retail",
      "poi_address": "1900 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this gas station offers clean, quality gas. They highlight the prices are consistently low and the service is efficient. They also like the convenient app for payment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7912-036c-75a7-8d74-7747c0b504e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-036c-75a7-8d74-7747c0b504e6",
        "storage_key": "property/6767906449165580/019d7912-036c-75a7-8d74-7747c0b504e6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.samsclub.com/club/8117-oklahoma-city-ok/fuel-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=8632309291013477456&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sam-s-club-gas-station",
      "poi_latitude": "35.607813",
      "poi_longitude": "-97.5480258",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-753-9751",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7912-1cca-71ba-b249-1ba6b3550d91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-1cca-71ba-b249-1ba6b3550d91",
        "storage_key": "property/6767906449165580/019d7912-1cca-71ba-b249-1ba6b3550d91.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ40NenmwcsocRUJQpcpAfzHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_e4af6f61-251d-4703-8338-178790b858c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Cabela's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1200 W Memorial Rd, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Retail mainstay stocking a huge inventory of hunting, fishing & camping supplies, plus boats & ATVs.",
      "poi_long_description": "People say this sporting goods store offers a wide variety of products for hunting, fishing, and other outdoor activities. They also highlight the helpful and friendly staff, and the convenient overnight RV parking.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7912-0621-76dd-be96-4d06e75b37a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0621-76dd-be96-4d06e75b37a5",
        "storage_key": "property/6767906449165580/019d7912-0621-76dd-be96-4d06e75b37a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.cabelas.com/us/ok/oklahoma-city/1200-w-memorial-rd.html?y_source=1_Mzk4Njc3MS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3642026274716462212&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cabela-s",
      "poi_latitude": "35.605703",
      "poi_longitude": "-97.5343856",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-546-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-08f0-76b8-88de-7735ef428505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-08f0-76b8-88de-7735ef428505",
        "storage_key": "property/6767906449165580/019cfb38-08f0-76b8-88de-7735ef428505.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVVHShxkcsocRhCwdv5kTizI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_ef50c987-8ade-4b7e-874a-58f02fadd435",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "iFLY Indoor Skydiving - Oklahoma City",
      "poi_type": "Entertainment",
      "poi_address": "13600 Pawnee Dr, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Indoor skydiving center flying kids and adults in a vertical wind tunnel, also offering birthday parties and corporate outings.",
      "poi_long_description": "People say this skydiving center offers a thrilling and unforgettable indoor skydiving experience. They highlight the fun, easy, and exciting atmosphere, and the patient, upbeat, and reassuring instructors. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7912-0497-7342-b8a5-b5a268707095.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0497-7342-b8a5-b5a268707095",
        "storage_key": "property/6767906449165580/019d7912-0497-7342-b8a5-b5a268707095.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "https://www.iflyworld.com/oklahoma-city/?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13546701854073548325&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ifly-indoor-skydiving-oklahoma-city",
      "poi_latitude": "35.607959",
      "poi_longitude": "-97.53839",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-300-4359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-0903-7309-b131-679323bacdfd",
        "storage_key": "property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRw5s2xYcsocRJe4tEpCN_7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_28823c07-78a2-4301-a436-1aa890db69a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Round1 Bowling & Arcade Quail Springs Mall",
      "poi_type": "Entertainment",
      "poi_address": "2501 W Memorial Rd SUITE 110, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Chain venue at Quail Springs Mall offering bowling, a variety of arcade games, karaoke, and billiards, plus snacks and a bar.",
      "poi_long_description": "People say this amusement center offers a wide variety of games, including arcade games, bowling, and crane machines, as well as cheap drinks and decent food. They also highlight the fun and exciting atmosphere, and the friendly and helpful staff.\n\nOther reviews mention the games and prizes can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7912-0ada-7428-ac06-72ee822ab3b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0ada-7428-ac06-72ee822ab3b0",
        "storage_key": "property/6767906449165580/019d7912-0ada-7428-ac06-72ee822ab3b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://round1usa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9896790231852657821&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "round1-bowling-arcade-quail-springs-mall",
      "poi_latitude": "35.6125263",
      "poi_longitude": "-97.5590432",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-896-9515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-0903-7309-b131-679323bacdfd",
        "storage_key": "property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdzWpZOkdsocRnSwiykd2WIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_70ffbd19-5432-44a8-89de-d5fc5dfab813",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Quail Creek Golf & Country Club",
      "poi_type": "Entertainment",
      "poi_address": "3501 Quail Creek Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Upscale facility, owned by members, featuring golf courses and tennis courts, plus a pool.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019d7912-0dd8-773d-b8b2-aabbf1f894c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0dd8-773d-b8b2-aabbf1f894c1",
        "storage_key": "property/6767906449165580/019d7912-0dd8-773d-b8b2-aabbf1f894c1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.quailcreekgcc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3160679487445955446&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "quail-creek-golf-country-club",
      "poi_latitude": "35.5992235",
      "poi_longitude": "-97.5817331",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-751-0811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb38-0903-7309-b131-679323bacdfd",
        "storage_key": "property/6767906449165580/019cfb38-0903-7309-b131-679323bacdfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJdotho8csocRdnMUcj_93Cs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_3cb6c933-cde6-41d2-aa66-4b983e6e1e61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Crossings Christian School (grades pre-K through 12)",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "crossings-christian-school-grades-pre-k-through-12",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3b387c23-3f02-48ac-b39c-77fbd494d641",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "poi_name": "Break Room 405",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "break-room-405",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_ad241eee2005a23e82fde4cf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e4025dcebf0f2249e73c27aa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_aff224a8dbca773fd0467f86",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_9dc2ae50018d060f2d46895d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6d96d14b77490e9847e33d15",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_076629b88a0ff0e1735d3659",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_1265f7fc-5dbd-4f08-9590-c1b67f8712c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "rating": "5.0",
      "name": "Sabrina Watson",
      "text": "My move here has been such an exciting experience! I absolutely love this apartment—it’s beautiful, glamorous, and feels like home. I’ve enjoyed every part of my stay and have never had any issues with the apartment or maintenance. The team has always been accommodating, kind, and responsive. I also love how quiet it is here—no disturbances at all, which makes it even better. Truly the best apartment community I’ve ever lived in!",
      "date": "2025-09-23",
      "title": ""
    },
    {
      "id": "custom_24b8cb9c-b9e9-4d88-993c-116908cdd45e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "rating": "5.0",
      "name": "Codi Gerjets",
      "text": "2400 is truly a wonderful place to call home!\n\nMy husband and I have lived here for the past two years, and our experience has been nothing short of fantastic. The community is well-maintained, and any issues are handled promptly and professionally by Lisa, the property manager. She genuinely cares about the residents and treats everyone like family, making sure concerns are addressed quickly and with kindness.\n\nOne thing we love most about living at 2400 is its perfect location in the heart of Quail Springs. While you're just minutes away from everything from grocery stores, gyms, shopping centers, and an incredible selection of restaurants, this community still feels peaceful and secluded from the hustle and bustle. It’s the best of both worlds: the convenience of city living with the tranquility of a quiet retreat.\n\nI’ve noticed some older reviews mentioning a former employee who was unprofessional. Trust me we all used to deal with her but rest assured, she is no longer part of the leasing office, and the team here truly values providing a welcoming and professional environment for all residents.\n\nIf you're looking for a safe, quiet, and beautifully maintained community with fantastic amenities, 2400 is an excellent choice! We’ve loved our time here and highly recommend it to anyone considering making this their new home.",
      "date": "2025-03-21",
      "title": ""
    },
    {
      "id": "custom_6ea078b0-fec6-498c-9582-d03b2bbc3c59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "rating": "5.0",
      "name": "Larry Kupp",
      "text": "I have lived at 24 Hundred Apartments over 2 years. The amenities are great. The pool, gym, dog parks, buildings, parking lots, garages and landscaping are all well maintained. They lease to like-minded tenants that fit well in this community. The office staff is easy to reach and maintenance is prompt and well skilled. Highly recommend.",
      "date": "2025-08-19",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_6bb1ccbb-3a61-4097-8f0e-faa095a4aa30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb39-40fc-724e-9ab1-b92d4b5ccdd7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of a modern community kitchen with island and seating.",
        "public_id": "019cfb39-40fc-724e-9ab1-b92d4b5ccdd7",
        "storage_key": "property/6767906449165580/019cfb39-40fc-724e-9ab1-b92d4b5ccdd7.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "24Hundred Apartments Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=637d3ac822182b0e0da9e444"
    },
    {
      "id": "custom_172e7eea-0931-4a11-aac6-47f946e989ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Video Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/L9dgjqc7Ssm?source=180"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79d-9155-75be-85b1-a3089da321ff",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "24hundred-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580"
    },
    {
      "lead_collector_id": "019cf79d-9233-751d-b0a2-33ee00a1d68a",
      "lead_source": "LANDING_PAGE",
      "name": "24hundred-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "generator",
      "page_item_url": "resort-style-pool-apartments-oklahoma-city",
      "search_query": "resort style pool apartments Oklahoma City",
      "category": "Amenity",
      "h1_title": "Resort Style Pool Apartments in OKC",
      "h2_subtitle": "Discover the ultimate lifestyle at 24Hundred Apartments with our resort style pool in Oklahoma City. Experience luxury living in OKC.",
      "page_copy": "Welcome to 24Hundred Apartments, where residents enjoy luxury living in the heart of Oklahoma City. Our community offers spacious one, two, and three-bedroom homes designed with modern amenities and style. A standout feature of 24Hundred is our resort style pool, providing the ideal setting for relaxation and fun. With plenty of tanning ledges and a nearby cabana, residents can unwind and socialize comfortably.\n\nLocated in Northwest Oklahoma City, our community is perfectly situated for both convenience and leisure. Beyond the pool, you'll find a host of amenities including a pool area cabana and preinstalled WiFi modem, all tailored to enhance your living experience. Discover the vibrancy of OKC living—schedule a tour and see the premier resort style pool apartments in Oklahoma City today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for 24 Hundred Apartments",
        "public_id": "019cfb37-e27d-71fa-922f-56721c66d838",
        "storage_key": "property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
        "width": 1055,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort Style Pool Apartments OKC | 24Hundred Apts",
      "seo_description": "Explore luxury living at 24Hundred Apartments with our stunning resort style pool in Oklahoma City. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-northwest-okc",
      "search_query": "dog friendly apartments Northwest Oklahoma City",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in Northwest OKC",
      "h2_subtitle": "24Hundred Apartments offers dog friendly homes in Northwest Oklahoma City. Join a pet-loving community today!",
      "page_copy": "At 24Hundred Apartments, we understand that pets are part of the family. Located in the vibrant Northwest Oklahoma City area, our dog-friendly apartments are the perfect place for both you and your furry friend. Choose from spacious one, two, and three-bedroom floor plans, each featuring modern amenities designed to make everyone feel at home, including those with paws.\n\nBeyond our welcoming interiors, our community provides an ideal environment for pet owners. Surrounded by lush landscaping and open spaces, residents and their pets can enjoy leisurely strolls around the neighborhood. Plus, you'll benefit from amenities such as a resort-style pool and on-site maintenance, ensuring a hassle-free living experience. Discover a pet-friendly lifestyle at 24Hundred Apartments today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for 24 Hundred Apartments",
        "public_id": "019cfb37-e27d-71fa-922f-56721c66d838",
        "storage_key": "property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
        "width": 1055,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments in NW OKC | 24Hundred Apts",
      "seo_description": "24Hundred Apartments offers dog friendly living in NW OKC. Enjoy spacious homes and a pet-loving community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "generator",
      "page_item_url": "gated-community-with-garages-okc",
      "search_query": "gated community with garages OKC",
      "category": "Amenity",
      "h1_title": "Gated Community with Garages in OKC",
      "h2_subtitle": "Discover 24Hundred Apartments, a gated community with convenient garage options in Oklahoma City. Enjoy secure and stylish living today.",
      "page_copy": "Experience the perfect blend of security and style at 24Hundred Apartments, a gated community located in Oklahoma City. Here, residents can enjoy the peace of mind that comes with living in a secure environment while benefiting from the convenience of available garages. Our beautifully designed one, two, and three-bedroom homes feature modern amenities, ensuring a comfortable lifestyle.\n\nNestled in the heart of OKC, our community offers more than just privacy. Amenities such as a resort-style pool, cabana, and preinstalled WiFi provide residents with a luxurious and connected living experience. Enjoy the added benefit of having a garage, perfect for protecting your vehicle from the elements or providing extra storage space. Come explore your next home at 24Hundred Apartments, where gated community living in Oklahoma City awaits.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for 24 Hundred Apartments",
        "public_id": "019cfb37-e27d-71fa-922f-56721c66d838",
        "storage_key": "property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
        "width": 1055,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community with Garages OKC | 24Hundred Apts",
      "seo_description": "Live securely at 24Hundred Apartments, a gated community with garages in OKC. Embrace comfort and peace of mind.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "generator",
      "page_item_url": "luxury-apartments-fitness-center-oklahoma",
      "search_query": "luxury apartments with fitness center Oklahoma",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Fitness Center",
      "h2_subtitle": "24Hundred Apartments offers luxury living with a fitness center in Oklahoma City. Embrace a healthier lifestyle with us.",
      "page_copy": "Welcome to 24Hundred Apartments, where luxury meets fitness in the heart of Oklahoma City. Our community offers high-end one, two, and three-bedroom homes, each designed with modern touches that elevate everyday living. Fitness enthusiasts will appreciate having access to a well-equipped fitness center right on site, making it simple to maintain an active lifestyle without leaving home.\n\nAlongside our fitness center, residents can enjoy a host of thoughtful amenities including a resort-style pool with tanning ledges and options for pet lovers in this dog-friendly neighborhood. Nestled in Northwest Oklahoma City, our community seamlessly combines luxury and convenience, ensuring a well-rounded living experience. Discover the perfect balance of health and luxury at 24Hundred Apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for 24 Hundred Apartments",
        "public_id": "019cfb37-e27d-71fa-922f-56721c66d838",
        "storage_key": "property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
        "width": 1055,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Fitness Center OK | 24Hundred",
      "seo_description": "24Hundred Apartments in OKC offers luxury living with a fitness center. Enjoy a healthy and stylish lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "generator",
      "page_item_url": "apartments-with-business-center-okc-73134",
      "search_query": "apartments with business center OKC 73134",
      "category": "Amenity",
      "h1_title": "Apartments with Business Center in OKC 73134",
      "h2_subtitle": "24Hundred Apartments offers well-appointed homes with a business center in the 73134 area of Oklahoma City. Work from home with ease.",
      "page_copy": "Experience the allure of work-life balance at 24Hundred Apartments, conveniently located in the 73134 zip code of Oklahoma City. Our community provides residents with the advantage of an on-site business center, perfectly suited for those who need a productive environment right at their doorstep. These spacious one, two, and three-bedroom homes are equipped with modern comforts that cater to both relaxation and efficiency.\n\nLiving at 24Hundred Apartments means enjoying not only a dedicated business center but also a wealth of resort-style amenities. From our tranquil pool area with cabana to convenient WiFi services powered by Cox, everything you need is within reach. Nestled in Northwest Oklahoma City, discover the ideal setting for both work and leisure. Welcome to a community where convenience and comfort meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for 24 Hundred Apartments",
        "public_id": "019cfb37-e27d-71fa-922f-56721c66d838",
        "storage_key": "property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
        "width": 1055,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Business Center OKC 73134 | 24Hundred",
      "seo_description": "24Hundred Apartments in OKC 73134 offer homes with a business center. Ideal for work-life balance.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-northwest-oklahoma-city",
      "search_query": "1 bedroom apartments northwest oklahoma city",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Northwest Oklahoma City",
      "h2_subtitle": "Discover stylish 1 bedroom apartments at 24Hundred in Northwest Oklahoma City. Modern design and great amenities await you.",
      "page_copy": "Find your perfect home at 24Hundred Apartments, offering beautiful 1 bedroom apartments in the vibrant neighborhood of Northwest Oklahoma City. Each unit is thoughtfully designed with open layouts, high ceilings, and modern finishes, providing a stylish and comfortable living space. Our homes feature walk-in closets and private patios, making everyday living both convenient and enjoyable.\n\nResidents of 24Hundred Apartments can take advantage of our community amenities that complement the luxurious interiors. Enjoy a refreshing dip in our resort-style pool or stay connected with preinstalled WiFi modem services by Cox. Located in a lively area with easy access to local dining and shopping, our 1 bedroom apartments provide the perfect blend of relaxation and excitement. Welcome to sophisticated living in Northwest Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for 24 Hundred Apartments",
        "public_id": "019cfb37-e27d-71fa-922f-56721c66d838",
        "storage_key": "property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
        "width": 1055,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apts Northwest Oklahoma City | 24Hundred",
      "seo_description": "Stylish 1 bedroom apartments at 24Hundred in Northwest Oklahoma City. Enjoy modern living and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-okc-73134",
      "search_query": "2 bedroom apartments okc 73134",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in OKC 73134",
      "h2_subtitle": "Explore spacious 2 bedroom apartments at 24Hundred in OKC's 73134 area. Designed for comfort and convenience.",
      "page_copy": "Discover spacious living at 24Hundred Apartments, where our 2 bedroom apartments in the heart of Oklahoma City's 73134 area offer the perfect blend of comfort and style. Each apartment is crafted with attention to detail, featuring high ceilings and open kitchens, perfect for entertaining or unwinding after a long day. With amenities like walk-in closets and private patios, you’ll find a home that suits your lifestyle.\n\nAt 24Hundred Apartments, residents benefit from an array of community features, including a resort-style pool with tanning ledges and convenient washer and dryer connections. You'll love living in Northwest OKC, where a vibrant neighborhood meets modern conveniences. Whether you are working from home or enjoying moments with family, our 2 bedroom apartments offer everything you need. Start your journey at 24Hundred Apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for 24 Hundred Apartments",
        "public_id": "019cfb37-e27d-71fa-922f-56721c66d838",
        "storage_key": "property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
        "width": 1055,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments OKC 73134 | 24Hundred",
      "seo_description": "Find spacious 2 bedroom apartments in OKC's 73134 at 24Hundred. Enjoy comfort, style, and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-oklahoma-city",
      "search_query": "3 bedroom apartments in oklahoma city",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments in Oklahoma City",
      "h2_subtitle": "Discover spacious 3 bedroom apartments at 24Hundred in Oklahoma City. Perfect for families or roommates.",
      "page_copy": "Welcome to 24Hundred Apartments, where you can experience the luxury of expansive 3 bedroom apartments in Oklahoma City. Our community offers stylish living spaces that are perfectly suited for families and roommates alike. Each apartment is thoughtfully designed with high ceilings, open-concept layouts, and ample storage spaces like walk-in closets, ensuring comfort and functionality for all residents.\n\nAt 24Hundred Apartments, you'll also appreciate our outstanding amenities such as the resort-style pool with cabana, ideal for relaxing weekends. In addition, the convenience of preinstalled WiFi powered by Cox makes staying connected a breeze. Located in the heart of Northwest Oklahoma City, our community offers easy access to local attractions, shopping, and dining. Experience a lifestyle of convenience and luxury with our spacious 3 bedroom homes today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for 24 Hundred Apartments",
        "public_id": "019cfb37-e27d-71fa-922f-56721c66d838",
        "storage_key": "property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
        "width": 1055,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Oklahoma City | 24Hundred",
      "seo_description": "Explore spacious 3 bedroom apartments in Oklahoma City at 24Hundred. Ideal living for families or roommates.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "generator",
      "page_item_url": "apartments-near-university-central-oklahoma",
      "search_query": "apartments near university of central oklahoma ok",
      "category": "School",
      "h1_title": "Apartments Near University of Central Oklahoma",
      "h2_subtitle": "Find your ideal home close to the University of Central Oklahoma with 24Hundred Apartments. Perfect for students and faculty alike.",
      "page_copy": "Located conveniently in Oklahoma City, 24Hundred Apartments offers modern living options that are ideal for students or faculty searching for apartments near the University of Central Oklahoma. Enjoy the blend of comfort and style in our well-designed one, two, or three-bedroom homes, featuring high ceilings, private patios, and expansive walk-in closets.\n\nOur community is equipped with a resort-style pool and on-site amenities designed to enhance your living experience. With preinstalled WiFi modems powered by Cox, seamless connectivity is at your fingertips. 24Hundred Apartments provides a dynamic environment where you can focus on academics while enjoying nearby shopping and dining options. Discover the convenience of living near the University of Central Oklahoma today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for 24 Hundred Apartments",
        "public_id": "019cfb37-e27d-71fa-922f-56721c66d838",
        "storage_key": "property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
        "width": 1055,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Central Oklahoma | 24Hundred",
      "seo_description": "Find ideal student living at 24Hundred, close to the University of Central Oklahoma. Perfect for students and faculty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "generator",
      "page_item_url": "apartments-close-to-oklahoma-christian-university",
      "search_query": "apartments close to oklahoma christian university northwest okc",
      "category": "School",
      "h1_title": "Apartments Close to Oklahoma Christian University",
      "h2_subtitle": "Discover convenient living near Oklahoma Christian University at 24Hundred. Perfectly located in Northwest OKC.",
      "page_copy": "For those seeking the perfect residence close to Oklahoma Christian University, 24Hundred Apartments offers an exceptional living experience in Northwest OKC. Our community is ideal for students and faculty alike, featuring thoughtfully-designed one, two, and three-bedroom homes with modern amenities like high ceilings and private patios.\n\nEnjoy an elevated lifestyle with access to resort-style amenities including a pool with tanning ledges and an outdoor cabana. These, combined with preinstalled WiFi modems powered by Cox, make life enjoyable and convenient. Situated in a vibrant neighborhood, 24Hundred Apartments provides everything you need within reach, from local cafes and shops to essential services. Experience seamless living near Oklahoma Christian University with us today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for 24 Hundred Apartments",
        "public_id": "019cfb37-e27d-71fa-922f-56721c66d838",
        "storage_key": "property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
        "width": 1055,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Oklahoma Christian University | 24Hundred",
      "seo_description": "Live near Oklahoma Christian University at 24Hundred, offering modern amenities and a convenient location in Northwest OKC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "generator",
      "page_item_url": "apartments-near-mercy-hospital-nw-okc",
      "search_query": "apartments near mercy hospital in northwest oklahoma city",
      "category": "Hospital",
      "h1_title": "Apartments Near Mercy Hospital NW OKC",
      "h2_subtitle": "Discover comfort at 24Hundred Apartments, perfectly located near Mercy Hospital in Northwest Oklahoma City.",
      "page_copy": "Located just a short distance from Mercy Hospital, 24Hundred Apartments offers the ideal residence for healthcare professionals and patients seeking convenience and comfort in Northwest Oklahoma City. We provide a range of one, two, and three-bedroom homes designed with your comfort in mind, featuring high ceilings, walk-in closets, and private patios for a relaxing lifestyle.\n\nOur community amenities include a shimmering resort-style pool with tanning ledges, alongside a cabana perfect for unwinding after a long day. Connectivity is never an issue with preinstalled WiFi modems powered by Cox, ensuring you stay connected effortlessly. With its strategic location near premier healthcare facilities, dining, and shopping options, 24Hundred Apartments offers an upscale living experience close to all the essentials. Come explore our community today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for 24 Hundred Apartments",
        "public_id": "019cfb37-e27d-71fa-922f-56721c66d838",
        "storage_key": "property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
        "width": 1055,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Mercy Hospital NW OKC | 24Hundred Apartments",
      "seo_description": "Live in comfort at 24Hundred, near Mercy Hospital in NW OKC. Discover spacious homes with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "generator",
      "page_item_url": "living-close-to-oklahoma-heart-hospital-okc",
      "search_query": "living close to oklahoma heart hospital okc",
      "category": "Hospital",
      "h1_title": "Living Close to Oklahoma Heart Hospital OKC",
      "h2_subtitle": "Experience convenient living at 24Hundred Apartments, situated just minutes from Oklahoma Heart Hospital in OKC.",
      "page_copy": "24Hundred Apartments is the perfect choice for those looking to live close to Oklahoma Heart Hospital in OKC. Our community offers stylish and spacious one, two, and three-bedroom homes equipped with modern features such as high ceilings, walk-in closets, and private patios that cater to a lifestyle of comfort and ease.\n\nEnjoy our on-site amenities including a resort-style pool with tanning ledges and a cabana, ideal for relaxation after a busy day. Connectivity is streamlined with preinstalled WiFi modems powered by Cox, ensuring that you are always linked with work or loved ones. Situated in a thriving part of Northwest Oklahoma City, 24Hundred Apartments offers a lifestyle enriched with convenience and luxury, making it the top choice for those connected to healthcare in the area. Arrange a visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for 24 Hundred Apartments",
        "public_id": "019cfb37-e27d-71fa-922f-56721c66d838",
        "storage_key": "property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
        "width": 1055,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Live Near Oklahoma Heart Hospital OKC | 24Hundred",
      "seo_description": "Find easy living at 24Hundred, close to Oklahoma Heart Hospital in OKC. Enjoy modern homes with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "generator",
      "page_item_url": "apartments-near-martin-park-nature-center-okc",
      "search_query": "apartments near Martin Park Nature Center Oklahoma City",
      "category": "Park",
      "h1_title": "Apartments Near Martin Park Nature Center OKC",
      "h2_subtitle": "Discover the serenity of living near Martin Park Nature Center at 24Hundred Apartments, where nature meets convenience.",
      "page_copy": "Nestled close to the renowned Martin Park Nature Center, 24Hundred Apartments offers residents a harmonious blend of nature and urban living in Oklahoma City. Choose from our beautifully designed one, two, or three-bedroom homes that provide a peaceful retreat with high ceilings, private patios, and spacious walk-in closets.\n\nEmbrace an active lifestyle with our resort-style pool featuring tanning ledges, or relax under the poolside cabana. Stay seamlessly connected with preinstalled WiFi modems powered by Cox, ensuring efficient living. Located in a vibrant part of Northwest OKC, our community offers easy access to scenic trails at Martin Park as well as shopping, dining, and entertainment. Experience the perfect balance of tranquility and convenience by visiting 24Hundred Apartments today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for 24 Hundred Apartments",
        "public_id": "019cfb37-e27d-71fa-922f-56721c66d838",
        "storage_key": "property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
        "width": 1055,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Martin Park Nature Center OKC | 24Hundred",
      "seo_description": "Live near Martin Park Nature Center at 24Hundred in OKC. Enjoy modern homes with nature views and luxurious amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "generator",
      "page_item_url": "apartments-close-to-stars-and-stripes-park-nw-okc",
      "search_query": "apartments close to Stars And Stripes Park NW Oklahoma City",
      "category": "Park",
      "h1_title": "Apartments Close to Stars and Stripes Park NW OKC",
      "h2_subtitle": "Located near Stars and Stripes Park, 24Hundred Apartments offer unbeatable convenience and comfort in NW Oklahoma City.",
      "page_copy": "24Hundred Apartments is the ideal choice for those who want to live close to Stars and Stripes Park in Northwest Oklahoma City. Our community features elegant one, two, and three-bedroom residences that are perfect for individuals or families who enjoy both urban living and outdoor adventures, thanks to high ceilings, spacious walk-in closets, and private patios.\n\nRelax by our stunning resort-style pool with tanning ledges, or enjoy the convenience of our cabana. WiFi connectivity is hassle-free with preinstalled modems powered by Cox, so you can easily stay connected. Just moments away from the recreation and beauty of Stars and Stripes Park, as well as NW OKC's shopping and dining locales, 24Hundred Apartments offers a luxurious and accessible lifestyle. Book a tour with us and explore why our community is right for you!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for 24 Hundred Apartments",
        "public_id": "019cfb37-e27d-71fa-922f-56721c66d838",
        "storage_key": "property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
        "width": 1055,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Stars and Stripes Park NW OKC | 24Hundred",
      "seo_description": "Enjoy living near Stars and Stripes Park at 24Hundred in NW OKC. Discover homes with modern amenities and outdoor access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "generator",
      "page_item_url": "bluff-creek-park-nearby-apartments-oklahoma-county",
      "search_query": "Bluff Creek Park nearby apartments Oklahoma County",
      "category": "Park",
      "h1_title": "Bluff Creek Park Nearby Apartments Oklahoma County",
      "h2_subtitle": "24Hundred Apartments offers an ideal location close to Bluff Creek Park, perfect for those seeking nature and comfort in Oklahoma County.",
      "page_copy": "If you're searching for an apartment that's conveniently located near Bluff Creek Park in Oklahoma County, look no further than 24Hundred Apartments. Our community features meticulously crafted one, two, and three-bedroom homes with expansive high ceilings, generous walk-in closets, and inviting private patios, making it a perfect blend of style and practicality.\n\nResidents enjoy a suite of amenities, including a stunning resort-style pool complete with tanning ledges and a cabana, ideal for social gatherings or quiet relaxation. Seamless internet connectivity is assured with preinstalled WiFi modems powered by Cox. Situated just minutes from Bluff Creek Park, renowned for its lush trails and outdoor activities, and close to shopping and dining in NW OKC, 24Hundred Apartments perfectly encapsulates the essence of modern living with easy access to nature. Schedule a visit and discover the difference!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for 24 Hundred Apartments",
        "public_id": "019cfb37-e27d-71fa-922f-56721c66d838",
        "storage_key": "property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
        "width": 1055,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to Bluff Creek Park | 24Hundred",
      "seo_description": "Live close to Bluff Creek Park at 24Hundred in Oklahoma County. Enjoy modern living with luxurious amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165580",
      "source": "generator",
      "page_item_url": "living-near-ec-hafer-park-edmond-ok",
      "search_query": "living near E.C. Hafer Park Edmond OK",
      "category": "Park",
      "h1_title": "Living Near E.C. Hafer Park Edmond OK",
      "h2_subtitle": "Experience the charm of living near E.C. Hafer Park at 24Hundred Apartments, where comfort meets nature.",
      "page_copy": "Experience the convenience of living near E.C. Hafer Park while enjoying the upscale amenities at 24Hundred Apartments, located in vibrant Oklahoma City. Choose from our range of spacious one, two, or three-bedroom homes that boast high ceilings, expansive walk-in closets, and tranquil private patios for an enhanced living experience.\n\nResidents are welcomed with a luxurious resort-style pool featuring tanning ledges and a relaxing cabana area, perfect for unwinding after exploring the trails and recreational opportunities at nearby E.C. Hafer Park. Stay effortlessly connected with our preinstalled WiFi modems powered by Cox. Nestled in NW Oklahoma City, you're close to the flourishing scene of dining and retail, while enjoying the peaceful serenity of nature close by. Discover why living at 24Hundred Apartments is a perfect blend of accessibility and tranquility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for 24 Hundred Apartments",
        "public_id": "019cfb37-e27d-71fa-922f-56721c66d838",
        "storage_key": "property/6767906449165580/019cfb37-e27d-71fa-922f-56721c66d838.webp",
        "width": 1055,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Live Near E.C. Hafer Park Edmond | 24Hundred",
      "seo_description": "Discover 24Hundred Apartments, offering luxury living near E.C. Hafer Park in Edmond, OK. Enjoy modern homes and top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5139"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-3BTB9LVLD6"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041150936"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/24hundred/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-M8PTD8QW"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165580/019d1bd6-9c3c-7379-bb66-65fe5c6a1738.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "9ac77edd-b138-4c10-98b5-5427a2a8841c"
    },
    {
      "ID": "custom_apartmentsync_config_id",
      "type": "STRING",
      "value": "3487"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "866-547-5630"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "63c834c0c3cf2b8a557f0691"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImpiWnNoK0VGcnp1My9PUTg4TFVlM2c9PSIsInZhbHVlIjoiVkhjN3krcnR2L2tyaFpFZlFBaHNXQT09IiwibWFjIjoiZjlmNjc5NjZhZjljZWU4YTI2NWU2NmEzNjRlODE4NzhlMmM1YTQxZGNmOGFhMmM3ZGQxMmEzMDViNzRhNjRkYiJ9"
    }
  ],
  "custom_qb_id": "5139",
  "custom_ga4_id": "G-3BTB9LVLD6",
  "custom_repli_id": "10041150936",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/24hundred/register/",
  "custom_google_gtm_id": "GTM-M8PTD8QW",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165580/019d1bd6-9c3c-7379-bb66-65fe5c6a1738.pdf",
  "custom_rentgrata_property_id": "9ac77edd-b138-4c10-98b5-5427a2a8841c",
  "custom_apartmentsync_config_id": "3487",
  "custom_ppc_tracking_phone_number": "866-547-5630",
  "custom_residentboost_apartment_id": "63c834c0c3cf2b8a557f0691",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImpiWnNoK0VGcnp1My9PUTg4TFVlM2c9PSIsInZhbHVlIjoiVkhjN3krcnR2L2tyaFpFZlFBaHNXQT09IiwibWFjIjoiZjlmNjc5NjZhZjljZWU4YTI2NWU2NmEzNjRlODE4NzhlMmM1YTQxZGNmOGFhMmM3ZGQxMmEzMDViNzRhNjRkYiJ9"
};

export const generatedAt = '2026-08-27T21:00:29.517Z';
